{
  "invoice": {
    "title": "Hóa đơn",
    "subtitle": "Danh sách hóa đơn liên merchant",
    "columns": {
      "number": "Số hóa đơn",
      "merchant": "Merchant",
      "issuedAt": "Ngày phát hành",
      "dueAt": "Hạn thanh toán",
      "amount": "Số tiền",
      "status": "Trạng thái",
      "actions": "Hành động"
    },
    "actions": {
      "view": "Xem",
      "download": "Tải PDF",
      "resendEmail": "Gửi lại email",
      "bulkResend": "Gửi lại hàng loạt",
      "markPaid": "Đánh dấu đã thanh toán",
      "creditNote": "Phát hành Credit Note",
      "debitNote": "Phát hành Debit Note",
      "reversePayment": "Hoàn tác thanh toán",
      "manualGenerate": "Tạo thủ công"
    },
    "status": {
      "draft": "Nháp",
      "issued": "Đã phát hành",
      "partiallyPaid": "Đã thanh toán một phần",
      "paid": "Đã thanh toán",
      "overdue": "Quá hạn",
      "cancelled": "Đã hủy"
    },
    "filters": {
      "merchant": "Merchant",
      "status": "Trạng thái",
      "periodFrom": "Từ ngày",
      "periodTo": "Đến ngày",
      "overdueOnly": "Chỉ quá hạn",
      "search": "Tìm theo số hóa đơn",
      "searchLabel": "Tìm kiếm",
      "searchPlaceholder": "Tìm theo mã hóa đơn, merchant…",
      "searchAria": "Tìm hóa đơn",
      "statusAria": "Lọc theo trạng thái",
      "allStatuses": "Tất cả trạng thái",
      "merchantPlaceholder": "Tất cả merchant",
      "periodFromAria": "Ngày bắt đầu kỳ",
      "periodToAria": "Ngày kết thúc kỳ",
      "overdueChipAria": "{{count}} hóa đơn quá hạn",
      "clearFilters": "Xóa bộ lọc"
    },
    "empty": {
      "title": "Không có hóa đơn nào",
      "body": "Điều chỉnh bộ lọc hoặc chờ chu kỳ xuất hóa đơn tiếp theo."
    },
    "errors": {
      "loadFailed": "Không tải được hóa đơn",
      "resendFailed": "Không gửi lại được email hóa đơn",
      "amountMismatch": "Số tiền thanh toán không khớp tổng hóa đơn"
    },
    "confirm": {
      "bulkResend": "Gửi lại email cho {{count}} hóa đơn?",
      "markPaid": "Xác nhận hóa đơn này đã được thanh toán đầy đủ?",
      "reverse": "Hoàn tác thanh toán? Hành động này được ghi log audit."
    },
    "detail": {
      "paymentHistory": "Lịch sử thanh toán",
      "versions": "Lịch sử phiên bản",
      "linkedDocs": "Tài liệu liên quan",
      "downloadPdf": "Tải PDF",
      "statusLabels": {
        "DRAFT": "Nháp",
        "SENT": "Đã gửi · Chờ thanh toán",
        "PARTIAL": "Một phần",
        "PAID": "Đã thanh toán",
        "OVERDUE": "Quá hạn",
        "VOID": "Đã hủy",
        "PENDING_APPROVAL": "Chờ phê duyệt"
      },
      "missingId": "Thiếu mã hóa đơn.",
      "backToInvoices": "Quay lại Invoices",
      "heading": "Hóa đơn {{number}}",
      "merchantPrefix": "Merchant:",
      "cyclePrefix": "Kỳ:",
      "createdPrefix": "Tạo lúc",
      "loading": "Đang tải…",
      "unavailable": "Không có dữ liệu chi tiết.",
      "resendDraftTooltip": "Không thể gửi lại hóa đơn DRAFT — hãy tạo trước",
      "cnDraftTooltip": "Hóa đơn phải ở trạng thái SENT trở lên mới phát hành được credit note",
      "dnNotImplementedTitle": "Debit Note chưa triển khai",
      "dnNotImplementedDesc": "Endpoint backend /admin/invoices/:id/debit-notes chưa sẵn sàng. Vui lòng dùng Credit Note hoặc liên hệ admin.",
      "dnNotImplementedTooltip": "Debit Note: endpoint backend chưa triển khai",
      "markPaidDraftTooltip": "Hóa đơn phải ở trạng thái SENT trở lên mới đánh dấu đã thanh toán",
      "lineItems": "Dòng hóa đơn",
      "lineItemsCols": {
        "order": "Đơn #",
        "chargeType": "Loại phí",
        "net": "Trước thuế",
        "taxRate": "Thuế suất",
        "tax": "Thuế",
        "gross": "Sau thuế"
      },
      "noLineItems": "Không có dòng hóa đơn.",
      "taxLinesTitle": "Dòng thuế (theo khu vực)",
      "taxable": "chịu thuế",
      "taxWord": "thuế",
      "reverseCharge": "tự tính thuế ngược",
      "subtotal": "Tạm tính",
      "creditApplied": "Tín dụng đã áp dụng",
      "taxLabel": "Thuế",
      "totalDue": "Tổng phải trả",
      "status": "Trạng thái",
      "duePrefix": "Hạn:",
      "netTermsPrefix": "Điều khoản:",
      "remainingPrefix": "Còn lại:",
      "timeline": "Dòng thời gian",
      "timelineLabels": {
        "created": "Đã tạo",
        "sent": "Đã gửi",
        "paid": "Đã thanh toán"
      },
      "timelineBy": {
        "system": "hệ thống",
        "admin": "admin",
        "pending": "chờ xử lý"
      },
      "auditMetadata": "Thông tin audit",
      "auditFields": {
        "invoiceId": "Mã hóa đơn",
        "merchantId": "Mã merchant",
        "version": "Phiên bản",
        "created": "Tạo lúc",
        "updated": "Cập nhật"
      },
      "chargeTypeLabels": {
        "ORDER_CHARGE": "Đơn hàng",
        "SURCHARGE_CHARGE": "Phụ phí",
        "EMBROIDERY_CHARGE": "Thêu"
      },
      "reverseConfirm": "Hoàn tác payment {{reference}} với số tiền {{amount}}?",
      "markPaidModal": {
        "title": "Đánh dấu đã thanh toán",
        "amountLabel": "Số tiền (USD)",
        "amountPositive": "Số tiền phải lớn hơn 0",
        "referenceRequired": "Bắt buộc nhập mã tham chiếu",
        "remaining": "Còn lại: {{amount}}",
        "gatewayLabel": "Cổng thanh toán",
        "referenceLabel": "Mã tham chiếu",
        "referencePlaceholder": "VD: SWIFT-DBS-2026-04-29-001",
        "proofLabel": "URL chứng từ (tùy chọn)",
        "proofPlaceholder": "https://…/proof.pdf",
        "notesLabel": "Ghi chú (tùy chọn)",
        "overThresholdNotice": "Cần admin phê duyệt — số tiền vượt ngưỡng $10,000 của kế toán.",
        "cancel": "Hủy",
        "submitting": "Đang gửi…",
        "submit": "Gửi",
        "adminApprovalTitle": "Cần admin phê duyệt",
        "adminApprovalDesc": "Số tiền vượt $10,000 — chỉ admin mới được đánh dấu đã thanh toán.",
        "adminApprovalTooltip": "Cần admin phê duyệt"
      },
      "toast": {
        "loadFailed": "Không tải được hóa đơn",
        "markPaidFailed": "Đánh dấu thanh toán thất bại",
        "paymentRecorded": "Đã ghi nhận thanh toán",
        "paymentRecordedDesc": "Đang chờ phê duyệt. Hãy phê duyệt từ danh sách lịch sử thanh toán.",
        "approveFailed": "Phê duyệt thất bại",
        "paymentApproved": "Đã phê duyệt thanh toán",
        "paymentApprovedDesc": "Trạng thái hóa đơn cập nhật thành PAID/PARTIAL.",
        "rejectReasonRequired": "Cần nhập lý do từ chối",
        "rejectReasonMin": "Tối thiểu 3 ký tự.",
        "rejectFailed": "Từ chối thất bại",
        "paymentRejected": "Đã từ chối thanh toán",
        "paymentRejectedDesc": "Đã thông báo cho merchant kèm lý do.",
        "reverseFailed": "Hoàn tác thất bại",
        "paymentReversed": "Đã hoàn tác thanh toán",
        "paymentReversedDesc": "Đã khôi phục số dư hóa đơn; bút toán sổ cái được đảo ngược.",
        "resendFailed": "Gửi lại thất bại",
        "emailQueued": "Đã xếp hàng email",
        "emailQueuedDesc": "Đã gửi lại email hóa đơn tới liên hệ billing của merchant.",
        "networkError": "Lỗi mạng - kiểm tra kết nối",
        "unknown": "Không xác định"
      },
      "approveModal": {
        "title": "Xem xét thanh toán đã gửi",
        "amount": "Số tiền",
        "gateway": "Cổng",
        "reference": "Mã tham chiếu",
        "submitted": "Đã gửi lúc",
        "notesPrefix": "Ghi chú:",
        "proofAttachment": "Chứng từ đính kèm",
        "proofAlt": "Chứng từ thanh toán",
        "proofPdfTitle": "Chứng từ thanh toán PDF",
        "openProof": "Mở file chứng từ ↗",
        "noProof": "Không có file chứng từ đính kèm.",
        "rejectReasonLabel": "Lý do từ chối",
        "rejectReasonPlaceholder": "Tối thiểu 3 ký tự — sẽ gửi cho merchant qua email",
        "reject": "Từ chối",
        "confirmReject": "Xác nhận từ chối",
        "rejecting": "Đang từ chối…",
        "approve": "Phê duyệt",
        "approving": "Đang phê duyệt…"
      }
    },
    "list": {
      "subtitle": "Quản lý hóa đơn của các merchant trên toàn hệ thống. Hóa đơn không thể chỉnh sửa — hãy phát hành credit note (giấy báo có) hoặc debit note (giấy báo nợ) thay vì sửa.",
      "generateManual": "+ Tạo thủ công",
      "columns": {
        "invoiceNumber": "Số hóa đơn",
        "type": "Loại",
        "merchant": "Merchant",
        "period": "Kỳ",
        "amount": "Số tiền",
        "paymentGateway": "Cổng thanh toán",
        "gatewayFee": "Phí cổng",
        "status": "Trạng thái",
        "due": "Hạn",
        "actions": "Hành động"
      },
      "selectAllAria": "Chọn tất cả trên trang",
      "selectRowAria": "Chọn hóa đơn {{number}}",
      "loading": "Đang tải hóa đơn…",
      "emptyFiltered": "Không có hóa đơn khớp bộ lọc hiện tại",
      "bulk": {
        "selected": "Đã chọn {{count}} hóa đơn",
        "eligibleNote": "({{count}} đủ điều kiện gửi lại — loại trừ DRAFT / VOID)",
        "resend": "Gửi lại email ({{count}})",
        "sending": "Đang gửi…",
        "clear": "Bỏ chọn",
        "noPermission": "Bạn không có quyền gửi lại email hóa đơn.",
        "selectEligible": "Chọn ít nhất một hóa đơn ở trạng thái SENT / PARTIAL / OVERDUE / PAID"
      },
      "toast": {
        "oneQueued": "Đã xếp hàng 1 email",
        "manyQueued": "Đã xếp hàng {{count}} email",
        "queuedDesc": "Đã gửi yêu cầu gửi lại hóa đơn thành công.",
        "partialQueued": "Đã xếp hàng {{queued}}/{{total}} email",
        "partialDesc": "{{count}} bị bỏ qua ({{reason}}).",
        "skippedTitle": "Đã bỏ qua gửi lại",
        "skippedDescFallback": "Không có email nào được xếp hàng.",
        "resendFailed": "Gửi lại thất bại"
      },
      "prefixTooltip": "Tiền tố đánh số: {{prefix}}"
    },
    "typeLabels": {
      "Payment": "Thanh toán",
      "Refund": "Hoàn tiền",
      "Surcharge": "Phụ phí"
    },
    "statusLabels": {
      "DRAFT": "Nháp",
      "SENT": "Đã gửi",
      "PARTIAL": "Một phần",
      "PAID": "Đã thanh toán",
      "OVERDUE": "Quá hạn",
      "VOID": "Đã hủy"
    },
    "paymentStatusLabels": {
      "PENDING_APPROVAL": "Chờ phê duyệt",
      "APPROVED": "Đã duyệt",
      "REJECTED": "Bị từ chối",
      "REVERSED": "Đã hoàn tác"
    },
    "pdfPreview": {
      "unavailable": "Không có bản xem trước PDF.",
      "draftHint": "Hóa đơn DRAFT chỉ tạo PDF sau khi chuyển sang SENT.",
      "label": "Xem trước PDF hóa đơn",
      "openNewTab": "Mở trong tab mới ↗",
      "iframeTitle": "Xem trước PDF hóa đơn {{number}}"
    },
    "paymentHistory": {
      "loading": "Đang tải lịch sử thanh toán…",
      "empty": "Chưa có thanh toán nào.",
      "reversedBadge": "Đã hoàn tác",
      "refPrefix": "Mã:",
      "submittedPrefix": "Đã gửi:",
      "approvedPrefix": "Đã duyệt:",
      "reversedPrefix": "Đã hoàn tác:",
      "rejectedPrefix": "Bị từ chối:",
      "reverseReasonPrefix": "Lý do hoàn tác:",
      "review": "Xem xét",
      "reverse": "Hoàn tác"
    },
    "markPaidModal": {
      "aria": "Đánh dấu Paid — Hóa đơn {{number}}",
      "title": "Đánh dấu Paid — Hóa đơn {{number}}",
      "subtitle": "Ghi nhận thanh toán cho hóa đơn này. Hành động được lưu vào audit log (nhật ký kiểm toán).",
      "outstanding": "Còn lại (outstanding)",
      "version": "Phiên bản",
      "amountLabel": "Số tiền (USD)",
      "amountHelp": "Mặc định = số dư còn lại. Có thể nhập thấp hơn cho thanh toán một phần (trạng thái sẽ là PARTIAL).",
      "amountPositive": "Số tiền phải lớn hơn 0.",
      "gatewayLabel": "Cổng thanh toán",
      "referenceLabel": "Mã tham chiếu",
      "referencePlaceholder": "VD: WIRE-20260517-1234",
      "referenceHelp": "Bắt buộc — mã wire/SWIFT/giao dịch để đối chiếu sau này.",
      "referenceMin": "Cần nhập mã tham chiếu (tối thiểu {{min}} ký tự).",
      "referenceMax": "Mã tham chiếu quá dài (tối đa {{max}} ký tự).",
      "notesLabel": "Ghi chú (tùy chọn)",
      "notesPlaceholder": "VD: Đã xác nhận trên cổng ngân hàng.",
      "thresholdBlock": "Số tiền vượt mức $10,000 cho phép của kế toán. Cần quyền invoice:mark_paid:unlimited (Admin/Super Admin) — hãy nhờ admin duyệt hoặc giảm số tiền.",
      "thresholdTooltip": "Số tiền vượt mức $10,000 — cần quyền invoice:mark_paid:unlimited (Admin).",
      "thresholdWarnTitle": "Cần quyền admin để duyệt số tiền này",
      "thresholdWarnDesc": "Số tiền vượt mức $10,000 — cần quyền invoice:mark_paid:unlimited (Admin/Super Admin).",
      "cancel": "Hủy",
      "submitting": "Đang xử lý…",
      "submit": "Đánh dấu Paid",
      "toast": {
        "success": "Đã đánh dấu hóa đơn là Paid",
        "successDesc": "Hóa đơn {{number}} cập nhật trạng thái thanh toán.",
        "conflictTitle": "Hóa đơn đã được người khác cập nhật",
        "conflictDesc": "Hóa đơn đã được người dùng khác cập nhật — hãy làm mới và thử lại.",
        "thresholdError": "Số tiền vượt mức cho phép — cần quyền invoice:mark_paid:unlimited.",
        "voidTitle": "Hóa đơn đã VOID",
        "voidDesc": "Hóa đơn đã VOID — không thể thanh toán.",
        "failTitle": "Không đánh dấu được Paid",
        "networkTitle": "Lỗi mạng",
        "networkDesc": "Kiểm tra kết nối và thử lại."
      }
    },
    "reverseModal": {
      "aria": "Hoàn tác thanh toán",
      "title": "Hoàn tác thanh toán",
      "subtitle": "Hành động này đảo ngược payment, tính lại trạng thái hóa đơn và ghi audit log. Chỉ dùng cho trường hợp bank bounce (giao dịch ngân hàng bị trả lại) hoặc nhập nhầm.",
      "amount": "Số tiền",
      "gateway": "Cổng",
      "reference": "Mã tham chiếu",
      "createdAt": "Ngày tạo",
      "approvedBy": "Người duyệt",
      "submittedBy": "Người gửi",
      "reasonLabel": "Lý do hoàn tác",
      "reasonPlaceholder": "VD: Ngân hàng báo wire bị trả lại do sai mã SWIFT BIC — hoàn tác và yêu cầu gửi lại.",
      "reasonMin": "Lý do hoàn tác cần tối thiểu {{min}} ký tự (hiện {{count}}).",
      "reasonMax": "Lý do hoàn tác tối đa {{max}} ký tự.",
      "reasonRemaining": "Còn cần {{count}} ký tự nữa.",
      "reasonCount": "{{count}}/{{max}}",
      "cancel": "Hủy",
      "submitting": "Đang hoàn tác…",
      "submit": "Hoàn tác thanh toán",
      "toast": {
        "success": "Đã hoàn tác thanh toán",
        "successDesc": "Payment {{reference}} đã được đảo ngược. Hóa đơn sẽ tự tính lại trạng thái.",
        "forbiddenTitle": "Không có quyền hoàn tác",
        "forbiddenDesc": "Bạn cần quyền invoice:payment_reverse để thực hiện thao tác này.",
        "notFoundTitle": "Không tìm thấy payment",
        "notFoundDesc": "Payment đã bị xóa hoặc thay đổi — danh sách sẽ làm mới.",
        "alreadyTitle": "Payment đã được hoàn tác",
        "alreadyDesc": "Người khác đã hoàn tác payment này — danh sách sẽ làm mới.",
        "reasonTooShort": "Lý do hoàn tác cần tối thiểu {{min}} ký tự.",
        "failTitle": "Hoàn tác thất bại",
        "failDesc": "Vui lòng thử lại.",
        "networkTitle": "Lỗi mạng",
        "networkDesc": "Kiểm tra kết nối và thử lại."
      }
    },
    "creditNoteModal": {
      "aria": "Phát hành Credit Note",
      "title": "Phát hành Credit Note",
      "subtitle": "Tạo CN-YYYYMM-XXXXX liên kết hóa đơn{{label}}. Backend sinh PDF và audit log.",
      "lineItemsLabel": "Dòng hóa đơn (chọn dòng liên quan — tùy chọn)",
      "noLineItems": "Hóa đơn chưa tải dòng. Credit note sẽ áp dụng cho toàn bộ hóa đơn nếu không chọn dòng nào.",
      "selectedSummary": "Đã chọn {{selected}}/{{total}} dòng · {{amount}}",
      "amountInvalid": "Nhập số tiền hợp lệ (lớn hơn 0).",
      "reasonMin": "Lý do tối thiểu {{min}} ký tự.",
      "amountExceeds": "Số tiền credit note vượt quá tổng hóa đơn. Nhập số nhỏ hơn hoặc bằng tổng hóa đơn.",
      "cancel": "Hủy",
      "submitting": "Đang phát hành…",
      "submit": "Phát hành Credit Note",
      "toast": {
        "success": "Credit Note {{number}} đã phát hành",
        "successDesc": "{{amount}} đã được ghi nhận. Đã tạo PDF và audit log.",
        "invalidTitle": "Dữ liệu không hợp lệ",
        "notFoundTitle": "Không tìm thấy hóa đơn",
        "failTitle": "Không phát hành được Credit Note",
        "networkTitle": "Lỗi mạng",
        "networkDesc": "Không kết nối được tới máy chủ. Vui lòng kiểm tra mạng và thử lại."
      }
    },
    "debitNoteModal": {
      "aria": "Phát hành Debit Note",
      "title": "Phát hành Debit Note",
      "subtitle": "Tạo DN-YYYYMM-XXXXX liên kết hóa đơn{{label}}. Backend sinh PDF và audit log.",
      "descLabel": "Mô tả khoản ghi nợ",
      "descPlaceholder": "Ví dụ: \"Phụ phí giao gấp cho OR\". Tối thiểu {{min}} ký tự.",
      "descHint": "{{count}}/{{max}} ký tự (tối thiểu {{min}}).",
      "descError": "Mô tả khoản ghi nợ phải có {{min}}-{{max}} ký tự.",
      "referenceLineItems": "Dòng hóa đơn gốc (chỉ tham khảo)",
      "amountInvalid": "Nhập số tiền hợp lệ (lớn hơn 0).",
      "reasonMin": "Lý do tối thiểu {{min}} ký tự.",
      "cancel": "Hủy",
      "submitting": "Đang phát hành…",
      "submit": "Phát hành Debit Note",
      "toast": {
        "success": "Debit Note {{number}} đã phát hành",
        "successDesc": "{{amount}} đã được ghi nhận. Đã tạo PDF và audit log.",
        "invalidTitle": "Dữ liệu không hợp lệ",
        "notFoundTitle": "Không tìm thấy hóa đơn",
        "failTitle": "Không phát hành được Debit Note",
        "networkTitle": "Lỗi mạng",
        "networkDesc": "Không kết nối được tới máy chủ. Vui lòng kiểm tra mạng và thử lại."
      }
    },
    "noteForm": {
      "amountLabel": "Số tiền (USD)",
      "amountPlaceholder": "0.00",
      "amountHint": "Số tiền theo USD. Nhập theo đô-la, hệ thống lưu cent.",
      "invoiceTotal": "Tổng hóa đơn: {{amount}}",
      "reasonLabel": "Lý do",
      "reasonPlaceholder": "Tối thiểu 10 ký tự — giải thích chi tiết (audit log lưu lại để phục vụ compliance/tuân thủ).",
      "reasonRemaining": "Còn cần {{count}} ký tự nữa (tối thiểu {{min}}).",
      "reasonCount": "{{count}}/{{max}} ký tự"
    }
  },
  "credit_memo": {
    "title": "Credit Memo",
    "subtitle": "Credit memo đã phát hành theo merchant",
    "columns": {
      "number": "Số memo",
      "merchant": "Merchant",
      "issuedAt": "Ngày phát hành",
      "amount": "Số tiền",
      "balance": "Số dư còn lại",
      "status": "Trạng thái",
      "reason": "Lý do",
      "appliedTo": "Áp dụng cho",
      "actions": "Hành động",
      "issuedBy": "Người phát hành",
      "notes": "Ghi chú"
    },
    "actions": {
      "issue": "Phát hành Credit Memo",
      "apply": "Áp dụng vào hóa đơn",
      "void": "Hủy bỏ",
      "approving": "Đang duyệt…",
      "applyShort": "Áp dụng",
      "applyTooltip": "Áp dụng credit này vào một hóa đơn",
      "cancel": "Hủy"
    },
    "status": {
      "draft": "Nháp",
      "issued": "Đã phát hành",
      "partiallyApplied": "Áp dụng một phần",
      "fullyApplied": "Đã áp dụng hết",
      "voided": "Đã hủy"
    },
    "empty": {
      "title": "Không có credit memo",
      "body": "Phát hành credit memo từ trang chi tiết hóa đơn.",
      "none": "Không tìm thấy credit memo nào",
      "filtered": "Không có credit memo nào khớp bộ lọc hiện tại"
    },
    "approvals": {
      "title": "Chờ phê duyệt",
      "approve": "Phê duyệt",
      "reject": "Từ chối",
      "requestChanges": "Yêu cầu chỉnh sửa"
    },
    "filters": {
      "allStatuses": "Tất cả trạng thái",
      "searchLabel": "Tìm kiếm",
      "searchPlaceholder": "Tìm số credit memo…",
      "searchAria": "Tìm kiếm credit memo",
      "statusAria": "Lọc theo trạng thái",
      "allMerchants": "Tất cả merchant",
      "clear": "Xóa bộ lọc"
    },
    "filterOptions": {
      "active": "Hoạt động",
      "applied": "Đã áp dụng",
      "partiallyApplied": "Áp dụng một phần",
      "converted": "Đã chuyển đổi",
      "refundedToBank": "Đã hoàn về ngân hàng",
      "pendingApproval": "Chờ phê duyệt",
      "rejected": "Đã từ chối"
    },
    "reason": {
      "goodwill": "Thiện chí",
      "refund": "Hoàn tiền",
      "overpayment": "Trả thừa",
      "negotiated": "Thương lượng"
    },
    "badge": {
      "active": "Hoạt động",
      "pending": "Chờ duyệt",
      "applied": "Đã áp dụng",
      "partial": "Một phần",
      "converted": "Đã chuyển đổi",
      "refunded": "Đã hoàn",
      "rejected": "Đã từ chối",
      "dormant": "Ngủ đông",
      "voided": "Đã hủy"
    },
    "stale": {
      "tooltip": "Không hoạt động trên 12 tháng — cân nhắc hủy hoặc áp dụng",
      "ariaLabel": "Credit memo tồn đọng (không hoạt động trên 12 tháng)",
      "label": "Tồn đọng"
    },
    "list": {
      "subtitle": "Phát hành credit, áp dụng vào hóa đơn, hủy khi cần",
      "pendingApprovalLink": "Chờ phê duyệt",
      "pendingApprovalLinkTooltip": "Mở hàng đợi chờ phê duyệt",
      "loading": "Đang tải credit memo…"
    },
    "toast": {
      "loadFailed": "Không tải được credit memo",
      "networkError": "Lỗi mạng",
      "networkErrorDesc": "Lỗi mạng — kiểm tra kết nối",
      "adminRequired": "Cần quyền admin",
      "adminRequiredDesc": "Chỉ admin mới có thể phê duyệt credit memo đang chờ duyệt.",
      "approveFailed": "Phê duyệt thất bại",
      "approved": "Đã phê duyệt credit memo",
      "approvedDesc": "Credit memo đã chuyển sang trạng thái Hoạt động.",
      "genericError": "Có lỗi xảy ra"
    },
    "approvalsPage": {
      "title": "Hàng đợi chờ phê duyệt",
      "subtitle": "Credit memo chờ duyệt — kế toán phát hành trên $500 cần admin xác nhận trước khi chuyển sang Hoạt động.",
      "readonlyPrefix": "Bạn không có quyền",
      "readonlySuffix": "— chỉ có thể xem danh sách. Nút Phê duyệt/Từ chối sẽ ẩn cho đến khi được cấp quyền admin.",
      "issuedByFilterLabel": "Người phát hành (kế toán)",
      "allAccountants": "Tất cả kế toán",
      "amountMin": "Số tiền tối thiểu (USD)",
      "amountMax": "Số tiền tối đa (USD)",
      "loading": "Đang tải danh sách chờ duyệt…",
      "emptyFiltered": "Không có yêu cầu chờ duyệt nào khớp bộ lọc hiện tại",
      "emptyNone": "Không có credit memo nào đang chờ duyệt",
      "overThresholdTooltip": "Trên $500 — cần admin phê duyệt",
      "loadFailed": "Không tải được danh sách chờ duyệt"
    },
    "apply": {
      "title": "Áp dụng credit memo · {{id}}",
      "merchantLabel": "Merchant:",
      "remainingLabel": "Còn lại:",
      "invoiceLabel": "Hóa đơn (cũ nhất trước)",
      "loadingInvoices": "Đang tải hóa đơn…",
      "noInvoicesPrefix": "Không có hóa đơn ISSUED/PARTIAL/OVERDUE cho merchant này. Tạo hóa đơn qua",
      "noInvoicesSuffix": "trước, hoặc chờ chu kỳ tạo hóa đơn tự động.",
      "selectInvoicePlaceholder": "— Chọn hóa đơn —",
      "outstanding": "còn nợ",
      "amountLabel": "Số tiền (USD)",
      "amountPlaceholder": "ví dụ 25.00",
      "maxHint": "Tối đa: {{max}} = min(credit còn lại {{remaining}}, hóa đơn còn nợ {{outstanding}})",
      "amountTooHigh": "Số tiền vượt giới hạn — tối đa {{max}}.",
      "submitting": "Đang áp dụng…",
      "errSelectInvoice": "Vui lòng chọn hóa đơn",
      "errAmountPositive": "Số tiền phải là số dương (USD)",
      "errAmountTooHigh": "Số tiền vượt giới hạn — tối đa {{max}} (min của credit còn lại và hóa đơn còn nợ)",
      "errInvoiceNotFound": "Không tìm thấy hóa đơn {{id}}",
      "errMissingVersion": "Phản hồi hóa đơn thiếu trường version — cấu trúc không hợp lệ",
      "errMerchantMismatch": "Hóa đơn thuộc merchant khác với credit memo",
      "toastPaidTitle": "Đã áp dụng credit — hóa đơn ĐÃ THANH TOÁN",
      "toastAppliedTitle": "Đã áp dụng credit memo",
      "toastPaidDesc": "Hóa đơn {{invoice}} đã được thanh toán đủ {{amount}}.",
      "toastAppliedDesc": "Đã áp dụng {{amount}} vào hóa đơn {{invoice}}."
    },
    "issue": {
      "merchantPlaceholder": "Chọn merchant chế độ INVOICE…",
      "merchantHint": "Chỉ merchant ở chế độ INVOICE mới được cấp credit memo.",
      "thresholdTitle": "Cần phê duyệt.",
      "thresholdBefore": "Số tiền vượt $500 — credit memo do kế toán phát hành vượt ngưỡng này sẽ được chuyển vào",
      "thresholdQueueLink": "hàng đợi chờ phê duyệt",
      "thresholdAfter": ". Admin phải phê duyệt trước khi credit chuyển sang Hoạt động.",
      "notesPlaceholder": "Lý do cấp credit thiện chí (3–1000 ký tự)…",
      "issueTypeLabel": "Loại phát hành:",
      "issueTypeHint": "(các loại khác được phát hành tự động bởi tiến trình hoàn tiền/trả thừa).",
      "submitTitleThreshold": "Sẽ được chuyển vào hàng đợi chờ phê duyệt",
      "submitting": "Đang phát hành…",
      "submitForApproval": "Gửi để phê duyệt",
      "submitDefault": "Phát hành credit memo",
      "errMerchantRequired": "Bắt buộc chọn merchant",
      "errAmountPositive": "Số tiền phải lớn hơn 0",
      "errNotesMin": "Ghi chú phải có ít nhất 3 ký tự",
      "toastFailed": "Phát hành credit memo thất bại",
      "toastPendingTitle": "Credit memo chờ admin phê duyệt",
      "toastIssuedTitle": "Đã phát hành credit memo",
      "toastPendingDesc": "Số tiền vượt $500 — đã chuyển vào hàng đợi chờ phê duyệt.",
      "toastIssuedDesc": "Credit memo đã Hoạt động và có thể áp dụng vào hóa đơn."
    },
    "actionsCell": {
      "approveTooltip": "Phê duyệt credit memo (chuyển sang Hoạt động)",
      "rejectTooltip": "Từ chối credit memo (chuyển sang Đã từ chối)",
      "rejectModalTitle": "Từ chối credit memo",
      "memoLabel": "Memo:",
      "amountLabel": "Số tiền:",
      "reasonLabel": "Lý do từ chối",
      "reasonPlaceholder": "Nêu rõ lý do từ chối (tối thiểu {{min}} ký tự)…",
      "charCount": "{{count}} / {{max}} ký tự (tối thiểu {{min}})",
      "rejectNotice": "Sau khi xác nhận, kế toán phát hành sẽ nhận email thông báo lý do từ chối. Bản ghi nhật ký kiểm toán được tạo tự động.",
      "rejecting": "Đang từ chối…",
      "rejectSubmit": "Từ chối credit memo",
      "noApprovePerm": "Bạn không có quyền phê duyệt credit memo.",
      "reasonRequired": "Bắt buộc nhập lý do — tối thiểu {{min}} ký tự, tối đa {{max}} ký tự.",
      "alreadyResolvedTitle": "Credit memo đã được xử lý",
      "alreadyResolvedDesc": "Một admin khác vừa phê duyệt/từ chối. Đang làm mới…",
      "rejectFailed": "Từ chối thất bại",
      "rejectedTitle": "Đã từ chối credit memo",
      "rejectedDesc": "Credit memo đã bị từ chối; kế toán đã được thông báo."
    }
  },
  "refund_task": {
    "title": "Yêu cầu hoàn tiền",
    "subtitle": "Hàng đợi phê duyệt 4 mắt",
    "columns": {
      "id": "Mã yêu cầu",
      "merchant": "Merchant",
      "amount": "Số tiền",
      "reason": "Lý do",
      "requester": "Người yêu cầu",
      "approver": "Người phê duyệt",
      "status": "Trạng thái"
    },
    "status": {
      "pendingApproval": "Chờ phê duyệt",
      "approved": "Đã phê duyệt",
      "rejected": "Đã từ chối",
      "processed": "Đã xử lý",
      "failed": "Thất bại"
    },
    "actions": {
      "approve": "Phê duyệt",
      "reject": "Từ chối",
      "process": "Xử lý hoàn tiền"
    },
    "errors": {
      "selfApproval": "Bạn không thể tự phê duyệt yêu cầu hoàn tiền của mình",
      "alreadyProcessed": "Yêu cầu hoàn tiền này đã được xử lý",
      "generic": "Có lỗi xảy ra"
    },
    "relative": {
      "justNow": "vừa xong",
      "minutes": "{{count}} phút trước",
      "hours": "{{count}} giờ trước",
      "days": "{{count}} ngày trước"
    },
    "toast": {
      "networkError": "Lỗi mạng",
      "networkErrorDescription": "Lỗi mạng - kiểm tra kết nối"
    },
    "filter": {
      "merchantLabel": "Lọc theo merchant",
      "merchantAria": "Lọc theo mã merchant",
      "merchantPlaceholder": "Mã merchant…",
      "clear": "Xóa"
    },
    "queue": {
      "title": "Hàng đợi hoàn tiền",
      "subtitle": "Hoàn tiền chuyển khoản thủ công — áp dụng nguyên tắc tách quyền (4 mắt).",
      "tab": {
        "pendingBankTransfer": "Chờ chuyển khoản",
        "completed": "Hoàn tất"
      },
      "column": {
        "taskNumber": "Mã yêu cầu",
        "merchant": "Merchant",
        "amount": "Số tiền",
        "bankAccount": "Tài khoản ngân hàng",
        "createdBy": "Người tạo",
        "completed": "Hoàn tất",
        "created": "Ngày tạo",
        "action": "Thao tác"
      },
      "loading": "Đang tải yêu cầu hoàn tiền…",
      "empty": "Không có yêu cầu hoàn tiền nào trong hàng đợi này",
      "sameUserTitle": "Trùng với người dùng hiện tại (chặn 4 mắt)",
      "youBadge": "bạn",
      "completeBlockedTitle": "Không thể hoàn tất yêu cầu hoàn tiền do bạn tạo (nguyên tắc 4 mắt). Một kế toán hoặc admin khác phải hoàn tất.",
      "completeTitle": "Đánh dấu hoàn tiền đã hoàn tất",
      "complete": "Hoàn tất",
      "refPrefix": "Mã: {{ref}}",
      "loadFailed": "Không tải được yêu cầu hoàn tiền"
    },
    "complete": {
      "proofInvalidFormat": "Định dạng không hợp lệ. Chỉ chấp nhận PDF, JPG hoặc PNG.",
      "proofTooLarge": "File vượt quá giới hạn 5MB (hiện tại {{size}}MB).",
      "bankRefMin": "Mã tham chiếu ngân hàng là bắt buộc (tối thiểu {{min}} ký tự)",
      "bankRefMax": "Mã tham chiếu ngân hàng quá dài (tối đa {{max}} ký tự)",
      "overrideReasonMin": "Lý do ghi đè là bắt buộc (tối thiểu {{min}} ký tự)",
      "overrideReasonMax": "Lý do ghi đè quá dài (tối đa {{max}} ký tự)",
      "sameUserAdmin": "Trùng người tạo — bật ghi đè admin kèm lý do (4 mắt)",
      "sameUserNonAdmin": "Cần một kế toán khác (nguyên tắc 4 mắt)",
      "proofUploadFailed": "Tải chứng từ thất bại. Bạn có thể bỏ file đính kèm và thử lại, hoặc liên hệ ops.",
      "toastFailed": "Hoàn tất hoàn tiền thất bại",
      "toastStaleTitle": "Yêu cầu không còn trong hàng đợi",
      "toastStaleDesc": "Yêu cầu này đã được hoàn tất hoặc đã bị xoá. Danh sách vừa được làm mới.",
      "toastSuccess": "Đã hoàn tiền",
      "toastSuccessDesc": "Yêu cầu {{taskNumber}} đã được đánh dấu hoàn tất",
      "networkError": "Lỗi mạng",
      "networkErrorDesc": "Lỗi mạng - kiểm tra kết nối",
      "title": "Hoàn tất hoàn tiền {{taskNumber}}",
      "summaryMerchant": "Merchant:",
      "summaryAmount": "Số tiền:",
      "summaryBankAccount": "Tài khoản ngân hàng:",
      "summaryCreatedBy": "Người tạo:",
      "bannerTitle": "Không thể hoàn tất yêu cầu hoàn tiền do bạn tạo (nguyên tắc 4 mắt).",
      "bannerAdmin": "Một kế toán hoặc admin khác phải hoàn tất. Với quyền admin, bạn có thể ghi đè bên dưới kèm lý do — thao tác này được ghi log audit.",
      "bannerNonAdmin": "Một kế toán hoặc admin khác phải hoàn tất. Nhờ một kế toán khác (hoặc admin có quyền ghi đè kèm lý do) hoàn tất yêu cầu này.",
      "bankRefLabel": "Mã tham chiếu ngân hàng",
      "bankRefPlaceholder": "vd: WIRE-20260517-9988",
      "bankRefHelp": "Bắt buộc — xác nhận wire / SWIFT sau khi chuyển khoản (được ghi log audit).",
      "notesLabel": "Ghi chú (tùy chọn)",
      "notesPlaceholder": "Ghi chú nội bộ — xác nhận wire, trao đổi, v.v.",
      "proofLabel": "Sao kê ngân hàng (tùy chọn)",
      "proofRemove": "Xóa",
      "proofHelp": "PDF / JPG / PNG, tối đa 5MB. Lưu trên file server riêng.",
      "overrideCheckbox": "Ghi đè admin (tách quyền)",
      "overrideReasonLabel": "Lý do ghi đè",
      "overrideReasonPlaceholder": "Vì sao bạn ghi đè 4 mắt? (được ghi log audit dưới dạng override_segregation)",
      "overrideReasonHelp": "Tối thiểu {{min}} ký tự. Ghi vào audit_log với entity_type=override_segregation.",
      "cancel": "Hủy",
      "submitting": "Đang hoàn tất…",
      "submit": "Hoàn tất hoàn tiền"
    }
  },
  "payment_request": {
    "title": "Yêu cầu tạm ứng",
    "subtitle": "Yêu cầu thanh toán thủ công chờ duyệt",
    "columns": {
      "number": "Mã PR",
      "merchant": "Merchant",
      "amount": "Số tiền",
      "requestedAt": "Ngày yêu cầu",
      "status": "Trạng thái",
      "date": "Ngày",
      "legalEntity": "Pháp nhân",
      "createdBy": "Người tạo"
    },
    "status": {
      "pending": "Chờ duyệt",
      "approved": "Đã duyệt",
      "paid": "Đã thanh toán",
      "rejected": "Đã từ chối",
      "expired": "Hết hạn"
    },
    "actions": {
      "approve": "Phê duyệt",
      "reject": "Từ chối",
      "markPaid": "Đánh dấu đã thanh toán",
      "create": "Payment Request mới"
    },
    "page": {
      "description": "Tài liệu PDF gửi merchant để hỗ trợ onboarding chuyển khoản ngân hàng. PR không tạo dòng tiền và không sửa được sau khi tạo."
    },
    "toast": {
      "created": "Đã tạo Payment Request",
      "createdDesc": "PR {{prNumber}} hiển thị trên cùng danh sách."
    },
    "loading": "Đang tải…",
    "empty": "Chưa có Payment Request nào.",
    "networkError": "Lỗi mạng - kiểm tra kết nối",
    "noPerm": "Bạn không có quyền tạo PR.",
    "noPermTitle": "Bạn cần quyền để tạo Payment Request.",
    "filters": {
      "search": "Tên merchant / Mã PR",
      "searchPlaceholder": "Tìm merchant hoặc PR-YYYYMM-XXXXX",
      "from": "Từ",
      "to": "Đến",
      "searchBtn": "Tìm"
    },
    "fields": {
      "name": "Tên",
      "phone": "Điện thoại",
      "email": "Email",
      "business_name": "Tên doanh nghiệp",
      "tax_id": "Mã số thuế",
      "business_address": "Địa chỉ doanh nghiệp",
      "zip_code": "Mã bưu chính"
    },
    "form": {
      "merchantRequired": "Vui lòng chọn merchant.",
      "legalEntityRequired": "Vui lòng chọn pháp nhân.",
      "amountPositive": "Số tiền phải là số dương (USD).",
      "descriptionRequired": "Mô tả là bắt buộc.",
      "descriptionMax": "Mô tả tối đa {{max}} ký tự.",
      "createSuccess": "Tạo Payment Request thành công",
      "createSuccessDesc": "Đã tạo PR {{prNumber}} cho merchant.",
      "createSuccessFallback": "Đã tạo PR mới.",
      "title": "Tạo Payment Request",
      "merchantInfoLegend": "Thông tin merchant trên PDF",
      "loadingMerchant": "Đang tải thông tin merchant…",
      "empty": "(trống)",
      "toggleHint": "Bật + giá trị trống → dòng đó bị bỏ qua trên PDF.",
      "loadingShort": "Đang tải…",
      "noLegalEntities": "Chưa có pháp nhân nào",
      "selectLegalEntity": "Chọn pháp nhân",
      "defaultSuffix": " (mặc định)",
      "bankAccount": "Tài khoản ngân hàng",
      "selectLegalEntityFirst": "Chọn pháp nhân trước",
      "selectBankAccount": "Chọn tài khoản ngân hàng",
      "primarySuffix": " · chính",
      "amount": "Số tiền (USD)",
      "description": "Mô tả",
      "descriptionHelp": "{{count}}/{{max}} ký tự · tự động điền \"{{default}}\", admin sửa được.",
      "cancel": "Hủy",
      "creating": "Đang tạo…",
      "submit": "Tạo PR"
    },
    "pdf": {
      "title": "Payment Request",
      "iframeTitle": "Bản xem trước PDF Payment Request {{prNumber}}",
      "notReady": "PDF chưa sẵn sàng.",
      "notReadyHint": "PDF được render bất đồng bộ — thử lại sau ~30 giây.",
      "close": "Đóng",
      "download": "Tải PDF"
    }
  },
  "legal_entity": {
    "title": "Pháp nhân",
    "subtitle": "Pháp nhân thu phí và tài khoản ngân hàng",
    "columns": {
      "name": "Tên",
      "taxId": "Mã số thuế",
      "country": "Quốc gia",
      "bankAccount": "Tài khoản NH",
      "isActive": "Đang hoạt động",
      "legalName": "Tên pháp lý",
      "taxConfig": "Cấu hình thuế",
      "timezone": "Múi giờ",
      "invoices": "Hóa đơn",
      "created": "Ngày tạo",
      "actions": "Hành động"
    },
    "actions": {
      "create": "Thêm pháp nhân",
      "edit": "Sửa",
      "deactivate": "Vô hiệu hóa",
      "addBankAccount": "Thêm tài khoản NH",
      "assignMerchant": "Gán merchant",
      "delete": "Xóa"
    },
    "tabs": {
      "details": "Chi tiết",
      "bankAccounts": "Tài khoản ngân hàng",
      "merchants": "Merchant"
    },
    "fields": {
      "name": "Tên pháp lý",
      "taxId": "Mã số thuế / VAT",
      "country": "Quốc gia",
      "address": "Địa chỉ",
      "currency": "Tiền tệ mặc định",
      "active": "Đang hoạt động"
    },
    "errors": {
      "duplicateTaxId": "Đã tồn tại pháp nhân với mã số thuế này",
      "cannotDeactivate": "Không thể vô hiệu hóa — pháp nhân đang gắn với merchant",
      "noOtherEntity": "Không có entity khác để áp dụng logo."
    },
    "common": {
      "cancel": "Hủy",
      "remove": "Gỡ",
      "removing": "Đang gỡ…",
      "networkTitle": "Lỗi mạng",
      "networkDesc": "Lỗi mạng — kiểm tra kết nối"
    },
    "page": {
      "subtitle": "Sổ đăng ký đa pháp nhân — hóa đơn/biên nhận phát hành theo entity. Mỗi entity giữ cấu hình thuế riêng (VAT / GST / SALES_TAX / NONE) và múi giờ IANA cho cron billing.",
      "newEntity": "+ Thêm entity",
      "searchPlaceholder": "Tìm theo tên hoặc mã số thuế…",
      "sort": "Sắp xếp",
      "sortNewest": "Mới nhất trước",
      "sortOldest": "Cũ nhất trước",
      "sortName": "Tên (A→Z)",
      "loading": "Đang tải pháp nhân…",
      "loadError": "Không tải được: {{error}}",
      "retry": "Thử lại",
      "empty": "Chưa có pháp nhân nào — bấm \"+ Thêm entity\" để khởi tạo Printway HK.",
      "defaultBadge": "Mặc định",
      "taxMissingTip": "Cảnh báo migration: chưa đặt cấu hình thuế cho entity này.",
      "taxNotConfigured": "Chưa cấu hình thuế",
      "timezoneMissingTip": "Cảnh báo migration: chưa đặt múi giờ — cron hóa đơn sẽ bỏ qua entity này.",
      "timezoneNotSet": "Chưa đặt múi giờ",
      "loadingShort": "Đang tải…",
      "setDefault": "Đặt mặc định"
    },
    "toasts": {
      "loadDetailFailed": "Không tải được entity",
      "setDefaultSuccess": "Đã đặt làm mặc định",
      "setDefaultFailed": "Không đặt được mặc định",
      "deleteBlockedTitle": "Không thể xoá",
      "deleteSuccess": "Đã xoá pháp nhân",
      "deleteFailed": "Không xoá được"
    },
    "logo": {
      "unknownError": "lỗi không xác định",
      "syncPartial": "Đã đồng bộ {{done}}/{{total}} entity. Lỗi: {{errors}}"
    },
    "delete": {
      "inUseDesc": "Có hóa đơn/biên nhận đang tham chiếu \"{{name}}\" ({{count}} chứng từ). Soft-archive vẫn giữ snapshot trên các bản cũ.",
      "defaultBlockedTitle": "Không thể xoá entity mặc định",
      "defaultBlockedDesc": "Đặt entity khác làm mặc định trước khi xoá entity hiện tại."
    },
    "setDefaultConfirm": {
      "title": "Đặt làm pháp nhân mặc định?",
      "desc": "Hóa đơn/biên nhận phát hành mới mà không khai báo entity sẽ dùng \"{{name}}\". Chứng từ cũ giữ snapshot không đổi."
    },
    "deleteConfirm": {
      "title": "Xoá pháp nhân?",
      "desc": "Xoá \"{{name}}\" ({{taxId}}). Hệ thống sẽ chặn nếu có {{count}} hóa đơn/biên nhận đang tham chiếu hoặc nếu đây là entity mặc định."
    },
    "form": {
      "editTitle": "Sửa pháp nhân",
      "createTitle": "Pháp nhân mới",
      "editNote": "Lưu ý: thay đổi chỉ áp dụng cho hóa đơn/biên nhận phát hành mới (snapshot pattern — chứng từ cũ giữ thông tin entity tại thời điểm phát hành).",
      "legacyTimezoneWarning": "Entity cũ — chưa đặt múi giờ. Đặt múi giờ để bật cron billing hóa đơn.",
      "codeLabel": "Mã entity",
      "codeHelp": "UPPER_SNAKE — dùng trong tiền tố chuỗi số hóa đơn / biên nhận.",
      "countryLabel": "Quốc gia (ISO-2)",
      "taxIdLabel": "Mã số thuế (legal_id)",
      "taxIdHelp": "Phải duy nhất giữa các entity.",
      "nameLabel": "Tên pháp lý",
      "addressLabel": "Địa chỉ",
      "bankInfoLabel": "Thông tin ngân hàng",
      "bankInfoPlaceholder": "DBS Bank HK / Account 63000304744 / SWIFT DHBKHKHH",
      "logoLabel": "Logo",
      "logoHelper": "PNG / JPEG / WEBP / SVG ≤ 2 MB. Hiển thị trên PDF hóa đơn + PDF yêu cầu thanh toán.",
      "applying": "Đang áp dụng…",
      "applyToAll": "Áp dụng cho tất cả",
      "timezoneLabel": "Múi giờ (IANA)",
      "timezoneWarning": "Chưa đặt múi giờ — đặt múi giờ để bật cron billing hóa đơn.",
      "saving": "Đang lưu…",
      "creating": "Đang tạo…",
      "saveChanges": "Lưu thay đổi",
      "createEntity": "Tạo entity",
      "logoMissingTitle": "Chưa có logo URL",
      "logoMissingDesc": "Nhập logo URL trước khi áp dụng cho các entity khác.",
      "logoSyncedTitle": "Đã đồng bộ logo",
      "logoSyncedDesc": "Logo đã được copy sang các pháp nhân khác.",
      "logoSyncFailed": "Không đồng bộ được logo",
      "logoApplyFailedTitle": "Áp dụng logo thất bại",
      "duplicateTaxCode": "Mã số thuế/Mã đã được dùng bởi entity khác",
      "preconditionFailed": "Bản ghi đã được chỉnh sửa ở session khác. Đóng và mở lại để tải bản mới.",
      "updateFailed": "Không cập nhật được entity",
      "createFailed": "Không tạo được entity",
      "updateSuccess": "Đã cập nhật pháp nhân",
      "createSuccess": "Đã tạo pháp nhân"
    },
    "merchants": {
      "pickRequired": "Chọn 1 merchant từ danh sách tìm kiếm.",
      "alreadyAssigned": "Merchant này đã được assign cho entity.",
      "alreadyAssignedShort": "Merchant đã được assign.",
      "assignFailed": "Không assign được merchant",
      "reassignedTitle": "Đã chuyển merchant sang entity này",
      "assignedTitle": "Đã assign merchant",
      "reassignedDesc": "Merchant đã được gỡ khỏi entity trước đó và gắn vào entity hiện tại. Snapshot chứng từ cũ không thay đổi.",
      "notFoundTitle": "Assignment không tồn tại",
      "removeFailed": "Không gỡ được merchant",
      "removedFallbackDesc": "Merchant sẽ dùng entity mặc định (id {{id}}…) cho các chứng từ mới. Snapshot chứng từ cũ không đổi.",
      "removedDesc": "Merchant sẽ dùng entity mặc định cho các chứng từ mới.",
      "removedTitle": "Đã gỡ merchant khỏi entity",
      "snapshotWarning": "Entity đang phục vụ {{count}} chứng từ. Thay đổi gán merchant chỉ áp dụng cho chứng từ phát hành sau — snapshot chứng từ cũ giữ nguyên.",
      "readonly": "Bạn không có quyền chỉnh sửa danh sách merchants (cần legal_entity:write).",
      "assignHeading": "Assign merchant",
      "assignSubheading": "Merchant không được assign sẽ dùng entity mặc định.",
      "searchLabel": "Tìm merchant",
      "searchPlaceholder": "Tìm theo tên, email, hoặc ID",
      "assigning": "Đang assign…",
      "addBtn": "Thêm merchant",
      "empty": "Chưa có merchant nào được assign. Mọi merchant sẽ dùng entity mặc định.",
      "col": {
        "merchant": "Merchant",
        "email": "Email",
        "assigned": "Ngày assign",
        "actions": "Hành động"
      }
    },
    "bank": {
      "errGateway": "Bắt buộc — chọn payment gateway",
      "errRequired": "Bắt buộc",
      "errSwift": "SWIFT phải 8 hoặc 11 ký tự alphanumeric viết hoa",
      "errPrimaryExists": "Đã có 1 bank primary cho entity này — bỏ tick primary của bank hiện tại trước, hoặc tạo non-primary rồi đổi sau.",
      "errSwiftInvalid": "SWIFT không hợp lệ",
      "addFailed": "Không thêm được bank account",
      "addedSnapshotTitle": "Bank đã thêm — snapshot không thay đổi",
      "addedSnapshotDesc": "Các hóa đơn/yêu cầu tạm ứng đã phát hành vẫn dùng thông tin bank ở thời điểm phát hành (snapshot).",
      "addedTitle": "Đã thêm bank account",
      "removePrimaryTitle": "Không thể xoá bank primary",
      "removePrimaryDesc": "Đặt primary cho một bank khác trước khi xoá bank primary hiện tại.",
      "removeBlockedTitle": "Không thể xoá bank",
      "removePrimary422": "Bank primary không thể xoá — đặt primary cho tài khoản khác trước.",
      "removeFailed": "Không xoá được bank account",
      "removedSnapshotTitle": "Bank đã gỡ — snapshot vẫn giữ",
      "removedSnapshotDesc": "Chứng từ cũ tham chiếu bank này vẫn hiển thị thông tin tại thời điểm phát hành.",
      "removedTitle": "Đã xoá bank account",
      "legend": "Tài khoản ngân hàng",
      "snapshotWarning": "Entity này đang được tham chiếu trên {{count}} hóa đơn/PR. Mọi thay đổi bank chỉ ảnh hưởng chứng từ phát hành sau khi lưu — snapshot chứng từ cũ giữ nguyên.",
      "readonly": "Bạn không có quyền chỉnh sửa bank accounts (cần permission legal_entity:write).",
      "col": {
        "holder": "Chủ tài khoản · Gateway",
        "number": "Số tài khoản",
        "swift": "SWIFT",
        "primary": "Primary",
        "actions": "Hành động"
      },
      "empty": "Chưa có bank account nào. Bấm \"+ Add bank\" để khởi tạo bank primary.",
      "primaryBadge": "Primary",
      "addBankBtn": "+ Thêm bank",
      "adding": "Đang thêm…",
      "addBankSubmit": "Thêm bank",
      "gatewayLabel": "Payment gateway",
      "gatewayBankTransfer": "Chuyển khoản ngân hàng",
      "holderLabel": "Chủ tài khoản",
      "numberLabel": "Số tài khoản",
      "nameLabel": "Tên ngân hàng",
      "locationLabel": "Địa điểm ngân hàng",
      "typeLabel": "Loại tài khoản",
      "swiftLabel": "Mã SWIFT",
      "swiftPlaceholder": "HSBCHKHHHKH (8 hoặc 11 ký tự)",
      "swiftHelp": "Để trống nếu không áp dụng. SWIFT phải 8 hoặc 11 ký tự alphanumeric.",
      "codeLabel": "Mã ngân hàng",
      "branchLabel": "Mã chi nhánh",
      "branchPlaceholder": "Mã định danh chi nhánh",
      "addressLabel": "Địa chỉ ngân hàng",
      "setPrimaryLabel": "Đặt làm bank primary cho entity này",
      "primaryHelp": "Chỉ 1 bank được tick primary mỗi entity. Bỏ tick bank primary hiện tại trước khi tick primary cho bank mới.",
      "typePlaceholder": "Thanh toán / Tiết kiệm / Doanh nghiệp",
      "namePlaceholder": "HSBC Hong Kong",
      "locationPlaceholder": "Central, Hong Kong",
      "codePlaceholder": "Routing / ABA / IFSC"
    },
    "tax": {
      "legend": "Cấu hình thuế",
      "noneHint": "Type = NONE — entity không phát hành hóa đơn thuế. Các trường bên dưới bị disable.",
      "requiredHint": "Registration number + standard rate là bắt buộc cho VAT/GST/SALES_TAX.",
      "typeLabel": "Loại thuế",
      "typeNone": "NONE (không thuế)",
      "rateLabel": "Thuế suất chuẩn (%)",
      "ratePlaceholder": "vd: 10 = 10%",
      "rateHelp": "0–30% (lưu dạng phân số thập phân).",
      "regLabel": "Số đăng ký",
      "regPlaceholder": "Số đăng ký VAT/GST",
      "jurisdictionLabel": "Khu vực pháp lý (ISO-3166)",
      "jurisdictionAuto": "Tự gợi ý từ quốc gia trong địa chỉ: {{country}}.",
      "invoiceLabelLabel": "Nhãn thuế trên hóa đơn",
      "invoiceLabelPlaceholder": "vd: \"VAT 10%\"",
      "reverseChargeLabel": "Đủ điều kiện reverse-charge",
      "reverseChargeHint": "(mặc định BẬT cho B2B EU)",
      "jurisdictions": {
        "HK": "HK — Hồng Kông",
        "VN": "VN — Việt Nam",
        "SG": "SG — Singapore",
        "CN": "CN — Trung Quốc",
        "JP": "JP — Nhật Bản",
        "KR": "KR — Hàn Quốc",
        "TH": "TH — Thái Lan",
        "MY": "MY — Malaysia",
        "PH": "PH — Philippines",
        "ID": "ID — Indonesia",
        "IN": "IN — Ấn Độ",
        "AE": "AE — UAE",
        "AU": "AU — Úc",
        "NZ": "NZ — New Zealand",
        "GB": "GB — Vương quốc Anh",
        "DE": "DE — Đức",
        "FR": "FR — Pháp",
        "NL": "NL — Hà Lan",
        "IT": "IT — Ý",
        "ES": "ES — Tây Ban Nha",
        "IE": "IE — Ireland",
        "US": "US — Hoa Kỳ",
        "US-CA": "US-CA — California",
        "US-NY": "US-NY — New York",
        "US-TX": "US-TX — Texas",
        "US-WA": "US-WA — Washington",
        "CA": "CA — Canada"
      }
    },
    "timezone": {
      "searchPlaceholder": "Tìm múi giờ (vd: Asia/Hong_Kong, hong, new york)…",
      "noMatch": "Không có múi giờ khớp \"{{query}}\".",
      "helper": "Cron hóa đơn sẽ chạy chu kỳ theo múi giờ này."
    }
  },
  "aging_report": {
    "title": "Báo cáo tuổi nợ",
    "subtitle": "Phân tích Gross + Net + DSO",
    "buckets": {
      "current": "Trong hạn",
      "1to30": "1-30 ngày",
      "31to60": "31-60 ngày",
      "61to90": "61-90 ngày",
      "over90": "Trên 90 ngày"
    },
    "metrics": {
      "gross": "AR Gộp",
      "net": "AR Thuần",
      "dso": "DSO (số ngày phải thu trung bình)"
    },
    "filters": {
      "asOfDate": "Tại ngày",
      "merchant": "Merchant",
      "merchantPlaceholder": "Chọn merchant…"
    },
    "actions": {
      "export": "Xuất CSV",
      "refresh": "Làm mới"
    },
    "page": {
      "description": "Khoản phải thu chưa trả, nhóm theo độ tuổi nợ (Gộp vs Thuần)"
    },
    "bucketLabels": {
      "0-7d": "0-7 NGÀY",
      "8-30d": "8-30 NGÀY",
      "30d+": "TRÊN 30 NGÀY"
    },
    "tooltips": {
      "grossNet": "Gộp = hóa đơn chưa trả + phí chưa xuất hóa đơn. Thuần = Gộp - credit memo còn hiệu lực (Printway nợ merchant).",
      "dso": "DSO = số ngày trung bình từ khi phát hành hóa đơn đến khi thanh toán. Càng thấp càng tốt."
    },
    "toast": {
      "loadFailed": "Không tải được báo cáo tuổi nợ",
      "networkError": "Lỗi mạng - kiểm tra kết nối",
      "unexpectedShape": "Định dạng phản hồi từ máy chủ không như mong đợi.",
      "unknownError": "Lỗi không xác định"
    },
    "tiles": {
      "dso": "DSO (NGÀY)",
      "dsoSub": "Số ngày phải thu trung bình",
      "totalGross": "TỔNG GỘP",
      "totalNet": "TỔNG THUẦN",
      "netSub": "Sau khi trừ credit memo còn hiệu lực",
      "invoicesCount": "{{count}} hóa đơn"
    },
    "byMerchant": {
      "title": "Theo Merchant",
      "hint": "Nhấn vào ô nhóm tuổi nợ để xem các hóa đơn tương ứng.",
      "colDso": "DSO",
      "colGross": "Phải thu Gộp",
      "colNet": "Phải thu Thuần",
      "overall": "Tổng cộng"
    },
    "loading": "Đang tải báo cáo tuổi nợ…",
    "loadingShort": "Đang tải…",
    "empty": {
      "title": "Không có khoản phải thu nào",
      "body": "Mọi hóa đơn đã được thanh toán hoặc chưa có merchant nào ở chế độ INVOICE. Các nhóm tuổi nợ sẽ xuất hiện khi hóa đơn quá hạn."
    }
  },
  "transfer_group": {
    "title": "Nhóm chuyển khoản",
    "subtitle": "Nhóm merchant cho payout",
    "columns": {
      "name": "Tên nhóm",
      "memberCount": "Số thành viên",
      "createdAt": "Ngày tạo",
      "isActive": "Đang hoạt động",
      "description": "Mô tả",
      "owner": "Chủ sở hữu",
      "perMemberLimit": "Hạn mức / thành viên",
      "status": "Trạng thái",
      "actions": "Hành động"
    },
    "actions": {
      "create": "Tạo nhóm",
      "edit": "Sửa",
      "addMember": "Thêm thành viên",
      "removeMember": "Xóa thành viên",
      "members": "Thành viên",
      "deactivate": "Vô hiệu hóa",
      "deactivated": "Đã vô hiệu hóa",
      "history": "Lịch sử",
      "reactivate": "Kích hoạt lại"
    },
    "page": {
      "description": "Danh sách trắng các nhóm merchant được phép chuyển khoản ngang hàng. Quản lý thành viên và hạn mức chuyển theo từng thành viên. Việc chặn chuyển khoản được quản lý ở Chi tiết merchant."
    },
    "toast": {
      "loadFailed": "Không tải được danh sách nhóm",
      "networkError": "Lỗi mạng",
      "checkConnection": "Kiểm tra kết nối",
      "deactivateFailed": "Không vô hiệu hóa được nhóm",
      "deactivated": "Đã vô hiệu hóa nhóm",
      "networkErrorDesc": "Lỗi mạng — kiểm tra kết nối",
      "unknownError": "Lỗi không xác định",
      "reactivated": "Đã kích hoạt lại nhóm",
      "reactivateFailed": "Kích hoạt lại nhóm thất bại"
    },
    "loading": "Đang tải nhóm…",
    "empty": "Chưa có nhóm chuyển khoản nào. Nhấn \"+ Tạo nhóm\" để tạo mới.",
    "status": {
      "active": "Đang hoạt động",
      "inactive": "Ngừng hoạt động"
    },
    "alreadyInactive": "Nhóm đã ngừng hoạt động",
    "confirm": {
      "deactivateTitle": "Vô hiệu hóa \"{{name}}\"?",
      "deactivateDesc": "Nhóm sẽ bị đánh dấu ngừng hoạt động. Thành viên hiện tại mất quyền chuyển khoản. Có thể kích hoạt lại qua nút Sửa sau."
    },
    "form": {
      "nameRequired": "Tên là bắt buộc",
      "nameTooLong": "Tên quá dài (tối đa 80 ký tự)",
      "minNumber": "Số tiền tối thiểu phải là số",
      "maxNumber": "Số tiền tối đa phải là số",
      "minMax": "Số tiền tối thiểu phải ≤ tối đa",
      "nameTaken": "Tên nhóm đã tồn tại",
      "updateFailed": "Cập nhật thất bại",
      "createFailed": "Tạo thất bại",
      "updated": "Đã cập nhật nhóm",
      "created": "Đã tạo nhóm",
      "editTitle": "Sửa nhóm chuyển khoản",
      "createTitle": "Nhóm chuyển khoản mới",
      "nameLabel": "Tên",
      "namePlaceholder": "vd. East-Asia Hub",
      "nameHelp": "Duy nhất trên toàn nền tảng. 1-80 ký tự.",
      "descriptionPlaceholder": "Merchant ở khu vực JP/KR/CN",
      "minAmount": "Số tiền tối thiểu (USD)",
      "maxAmount": "Số tiền tối đa (USD)",
      "cancel": "Hủy",
      "saving": "Đang lưu…",
      "creating": "Đang tạo…",
      "saveChanges": "Lưu thay đổi",
      "createGroup": "Tạo nhóm",
      "amountDecimals": "Số tiền chỉ được tối đa 2 chữ số sau dấu phẩy",
      "amountNegative": "Số tiền không được âm"
    },
    "members": {
      "loadFailed": "Không tải được thành viên",
      "historyLoadFailed": "Không tải được lịch sử",
      "pickMerchant": "Chọn một merchant từ kết quả tìm kiếm",
      "alreadyMember": "Merchant này đã là thành viên.",
      "added": "Đã thêm thành viên",
      "removeFailed": "Không xóa được thành viên",
      "removed": "Đã xóa thành viên",
      "title": "Quản lý nhóm — {{name}}",
      "readonlyBadge": "Ngừng hoạt động (chỉ đọc)",
      "membersTab": "Thành viên ({{count}})",
      "historyTab": "Lịch sử",
      "addMerchant": "Thêm merchant",
      "inactiveHint": "Nhóm đang ngừng hoạt động — kích hoạt lại qua nút Sửa để thêm thành viên.",
      "searchMerchant": "Tìm merchant",
      "searchPlaceholder": "Tìm theo tên, email hoặc ID",
      "unlimited": "Không giới hạn (không áp hạn mức theo thành viên)",
      "maxPerTransfer": "Tối đa mỗi lần chuyển (cent)",
      "maxCount": "Số lần tối đa / tháng",
      "adding": "Đang thêm…",
      "addMemberBtn": "Thêm thành viên",
      "colMerchant": "Merchant",
      "colPerTransfer": "Mỗi lần chuyển",
      "colPerMonth": "Mỗi tháng",
      "colStatus": "Trạng thái",
      "colActions": "Hành động",
      "loadingMembers": "Đang tải thành viên…",
      "noMembers": "Chưa có thành viên nào.",
      "unlimitedValue": "Không giới hạn",
      "perMonthSuffix": "{{count}}/tháng",
      "blocked": "Bị chặn",
      "blockedReason": "Bị chặn — {{reason}}",
      "blockedTooltip": "Bị chặn chuyển khoản. Bỏ chặn ở Chi tiết merchant.",
      "remove": "Xóa",
      "historyBlurb": "Các giao dịch chuyển khoản gần đây trong nhóm này. Dùng liên kết để xem bộ lọc Giao dịch đầy đủ, hoặc xuất CSV để lưu phục vụ audit.",
      "viewInTransactions": "Xem trong Giao dịch",
      "exportCsv": "Xuất CSV",
      "histDate": "Ngày",
      "histSender": "Người gửi",
      "histReceiver": "Người nhận",
      "histAmount": "Số tiền",
      "loadingHistory": "Đang tải lịch sử…",
      "noTransfers": "Chưa có giao dịch chuyển khoản nào.",
      "close": "Đóng",
      "noWallet": "Chưa có ví",
      "noWalletTooltip": "Merchant này chưa có ví hoạt động — không thể nhận chuyển khoản cho đến khi hoàn tất onboarding."
    },
    "history": {
      "title": "Lịch sử chuyển — {{name}}",
      "loading": "Đang tải…",
      "empty": "Chưa có giao dịch chuyển nào qua nhóm này.",
      "date": "Ngày",
      "sender": "Người gửi",
      "recipient": "Người nhận",
      "amount": "Số tiền",
      "note": "Ghi chú",
      "exportCsv": "Xuất CSV",
      "close": "Đóng"
    }
  },
  "topup_review": {
    "title": "Duyệt nạp tiền",
    "subtitle": "Nạp tiền thủ công qua ngân hàng chờ duyệt",
    "columns": {
      "merchant": "Merchant",
      "amount": "Số tiền",
      "bank": "Ngân hàng",
      "reference": "Mã tham chiếu",
      "uploadedAt": "Ngày tải lên",
      "status": "Trạng thái"
    },
    "status": {
      "pending": "Chờ duyệt",
      "approved": "Đã duyệt",
      "rejected": "Đã từ chối"
    },
    "actions": {
      "approve": "Duyệt",
      "reject": "Từ chối",
      "viewProof": "Xem chứng từ"
    },
    "fields": {
      "verification": "Ghi chú xác minh",
      "rejectionReason": "Lý do từ chối"
    },
    "unknown": "Không xác định",
    "networkError": "Lỗi mạng — kiểm tra kết nối",
    "relative": {
      "seconds": "{{count}} giây trước",
      "minutes": "{{count}} phút trước",
      "hours": "{{count}} giờ trước",
      "days": "{{count}} ngày trước",
      "months": "{{count}} tháng trước"
    },
    "raceLoser": {
      "title": "Đã được xử lý bởi admin khác",
      "description": "Yêu cầu này đã được duyệt/từ chối bởi một admin khác — danh sách đã được làm mới."
    },
    "queue": {
      "title": "Hàng đợi nạp tiền",
      "subtitle": "Xem và duyệt yêu cầu nạp tiền thủ công (cũ nhất trước)",
      "queuePill": "Cũ nhất trước · {{count}} trong hàng đợi",
      "exportCsv": "Xuất CSV",
      "tab": {
        "all": "Tất cả",
        "pending": "Chờ duyệt",
        "approved": "Đã duyệt",
        "rejected": "Đã từ chối",
        "flagged": "Bị gắn cờ"
      },
      "filter": {
        "merchant": "Merchant",
        "allMerchants": "Tất cả merchant",
        "gateway": "Cổng",
        "allGateways": "Tất cả cổng",
        "from": "Từ",
        "to": "Đến",
        "clear": "Xóa bộ lọc"
      },
      "loading": "Đang tải hàng đợi nạp tiền…",
      "column": {
        "id": "ID",
        "merchant": "Merchant",
        "amount": "Số tiền",
        "gateway": "Cổng",
        "txId": "Mã giao dịch",
        "date": "Ngày",
        "status": "Trạng thái",
        "actions": "Thao tác"
      },
      "flaggedTitle": "Bị gắn cờ để rà soát gian lận",
      "approve": "Duyệt",
      "cancel": "Huỷ",
      "autoWebhook": "Tự động qua webhook",
      "reject": "Từ chối",
      "review": "Xem xét",
      "loadFailed": "Không tải được hàng đợi nạp tiền",
      "detailLoadFailed": "Không tải được chi tiết yêu cầu",
      "forceOverrideMin": "Force-approve cần lý do tối thiểu 10 ký tự (audit log).",
      "approveFailed": "Duyệt thất bại",
      "approveSuccess": "Đã duyệt nạp tiền",
      "approveSuccessDesc": "Đã ghi có vào ví và thông báo cho merchant.",
      "rejectReasonMin": "Lý do từ chối là bắt buộc (tối thiểu 3 ký tự).",
      "rejectFailed": "Từ chối thất bại",
      "rejectSuccess": "Đã từ chối nạp tiền",
      "rejectSuccessDesc": "Đã thông báo cho merchant kèm lý do.",
      "flagFailed": "Gắn/bỏ cờ thất bại",
      "flagMarked": "Đã gắn cờ nghi ngờ",
      "flagCleared": "Đã bỏ cờ",
      "flagDesc": "Chỉ nội bộ — merchant không được thông báo.",
      "confirmApproveTitleAmount": "Duyệt nạp tiền {{amount}}?",
      "confirmApproveTitle": "Duyệt nạp tiền?",
      "forceApproveTier1Bold": "Force-approve tier-1.",
      "forceApproveTier1Body": "Tier-1 thường được webhook duyệt tự động. Cần lý do tối thiểu 10 ký tự — sẽ ghi audit log.",
      "confirmApproveBody": "Thao tác này ghi có vào ví merchant và tạo bút toán sổ cái. Không thể hoàn tác.",
      "forceOverridePlaceholder": "Lý do force-approve (≥10 ký tự, audit log)",
      "internalNotePlaceholder": "Ghi chú nội bộ (lưu vết audit, tùy chọn)",
      "forceApprove": "Force approve",
      "emptyTitle": "Không có yêu cầu nạp tiền nào trong khung này",
      "emptyBody": "Khi merchant gửi yêu cầu nạp tiền, chúng sẽ xuất hiện ở đây để rà soát."
    },
    "drawer": {
      "closeDrawer": "Đóng ngăn kéo",
      "close": "Đóng",
      "fallbackName": "Yêu cầu nạp tiền",
      "loading": "Đang tải…",
      "flagged": "Bị gắn cờ",
      "flagAsSuspicious": "Gắn cờ nghi ngờ",
      "amount": "Số tiền",
      "original": "Gốc:",
      "fxLocked": " · FX khóa @ {{rate}}",
      "gateway": "Cổng",
      "tier": "Tier",
      "transactionId": "Mã giao dịch",
      "receipt": "Biên lai",
      "openReceipt": "Mở biên lai",
      "download": "Tải xuống",
      "merchantNote": "Ghi chú của merchant",
      "createdAt": "Tạo lúc",
      "approvedAt": "Duyệt lúc",
      "rejectedReason": "Lý do từ chối",
      "rejectThis": "Từ chối yêu cầu này",
      "reason": "Lý do",
      "rejectReasonPlaceholder": "Lý do từ chối (gửi cho merchant)",
      "internalNote": "Ghi chú nội bộ (lưu vết audit, tùy chọn)",
      "internalNotePlaceholder": "Chỉ admin team thấy",
      "reject": "Từ chối",
      "approve": "Duyệt",
      "tier1AutoWebhook": "Tier 1 — tự động qua webhook",
      "forceApproveTitle": "Bỏ qua auto-approve tier-1 (được ghi log audit)",
      "forceApprove": "Force approve"
    },
    "reviews": {
      "title": "Rà soát nạp tiền",
      "subtitle": "Hàng tự xác minh duyệt chỉ với một cú nhấp. Hàng cần rà soát thủ công sẽ mở modal chứng từ 4 phần.",
      "overdue": "{{count}} quá hạn (vi phạm SLA)",
      "approveSuccessDescRef": "Đã ghi có vào ví. Mã: {{ref}}.",
      "approveSuccessDesc": "Đã ghi có vào ví.",
      "rejectSuccessDescReason": "Đã từ chối — lý do: {{reason}}.",
      "rejectSuccessDesc": "Đã từ chối nạp tiền.",
      "loading": "Đang tải rà soát nạp tiền…",
      "errorTitle": "Không tải được danh sách rà soát.",
      "retry": "Thử lại",
      "emptyTitle": "Không có rà soát nạp tiền nào trong khung này",
      "emptyBody": "Thử xóa bộ lọc hoặc đổi trạng thái.",
      "merchantFallback": "Merchant …{{id}}",
      "ageMinutes": "Tuổi: {{count}} phút",
      "approving": "Đang duyệt…",
      "filter": {
        "status": "Trạng thái",
        "all": "Tất cả",
        "verification": "Xác minh",
        "sla": "SLA",
        "slaFresh": "Mới (< 2h)",
        "slaYellow": "Vàng (2-4h)",
        "slaRed": "Đỏ (> 4h)",
        "merchant": "Merchant"
      },
      "verification": {
        "auto": "Tự xác minh",
        "manual": "Rà soát thủ công"
      },
      "slaBadge": {
        "green": "XANH",
        "yellow": "VÀNG",
        "red": "ĐỎ"
      },
      "column": {
        "merchant": "Merchant",
        "amount": "Số tiền",
        "verification": "Xác minh",
        "sla": "SLA",
        "created": "Ngày tạo",
        "status": "Trạng thái",
        "rejectReason": "Lý do từ chối",
        "reviewer": "Người duyệt",
        "actions": "Thao tác"
      },
      "cancelledByMerchant": "Người bán tự huỷ"
    },
    "modal": {
      "ariaLabel": "Rà soát chứng từ nạp tiền",
      "title": "Rà soát chứng từ nạp tiền",
      "ageMinutes": "Tuổi: {{count}} phút",
      "sla": "SLA: {{age}}",
      "section1Title": "1. Nguồn IMAP",
      "section1Subtitle": "Nội dung email ngân hàng gốc + trường do server phân tích",
      "parsed": "Đã phân tích",
      "sender": "Người gửi",
      "amount": "Số tiền",
      "memo": "Nội dung",
      "timestamp": "Thời điểm",
      "rawImap": "Nội dung IMAP gốc",
      "noImap": "(không có nội dung IMAP)",
      "section2Title": "2. Ghi chú của merchant",
      "section2Subtitle": "Nội dung tự do merchant gửi kèm yêu cầu nạp tiền",
      "noMemo": "(không có ghi chú)",
      "section3Title": "3. Ảnh chụp / hóa đơn tải lên",
      "section3Subtitle": "≤5MB · áp dụng phía server",
      "screenshotAlt": "Ảnh chụp chứng từ nạp tiền",
      "noScreenshot": "(chưa tải ảnh chụp)",
      "screenshotOpen": "Mở chứng từ ở tab mới",
      "screenshotLoadFailed": "Không tải được ảnh chứng từ. Mở ở tab mới bên dưới.",
      "section4Title": "4. Bối cảnh ví",
      "section4Subtitle": "Số dư · giao dịch gần đây · cờ nghi ngờ",
      "walletBalance": "Số dư ví",
      "suspiciousFlags": "Cờ nghi ngờ",
      "recentTransactions": "Giao dịch gần đây",
      "noTransactions": "(không có giao dịch trong khoảng này)",
      "approveNotes": "Ghi chú khi duyệt (tùy chọn)",
      "approveNotesPlaceholder": "Ghi chú nội bộ tùy chọn — ghi vào audit log",
      "rejectThis": "Từ chối nạp tiền này",
      "rejectReasonAria": "Lý do từ chối",
      "selectReason": "Chọn lý do…",
      "freeTextPlaceholder": "Lý do tự do (bắt buộc)",
      "cancel": "Hủy",
      "reject": "Từ chối",
      "approve": "Duyệt",
      "selectReasonError": "Vui lòng chọn lý do từ chối.",
      "otherRequiredError": "Bắt buộc nhập lý do khi chọn \"Other\".",
      "rejectReason": {
        "wrong_amount": "Sai số tiền",
        "wrong_memo": "Sai nội dung",
        "unknown_sender": "Người gửi lạ",
        "duplicate": "Trùng lặp",
        "suspicious": "Nghi ngờ",
        "missing_proof": "Thiếu chứng từ",
        "other": "Khác (bắt buộc nhập lý do)"
      }
    }
  },
  "credit": {
    "title": "Tín dụng",
    "subtitle": "Số dư tín dụng liên merchant",
    "columns": {
      "merchant": "Merchant",
      "balance": "Số dư",
      "lastTopup": "Lần nạp gần nhất",
      "lifetime": "Tổng đã chi",
      "amount": "Số tiền",
      "used": "Đã dùng",
      "remaining": "Còn lại",
      "expiresAt": "Hết hạn",
      "reason": "Lý do",
      "createdBy": "Người tạo",
      "version": "Phiên bản",
      "status": "Trạng thái",
      "actions": "Hành động"
    },
    "actions": {
      "grant": "Cấp tín dụng",
      "revoke": "Thu hồi",
      "viewHistory": "Xem lịch sử"
    },
    "filters": {
      "merchant": "Merchant",
      "minBalance": "Số dư tối thiểu",
      "maxBalance": "Số dư tối đa",
      "merchantLabel": "Merchant (tìm theo tên / email)",
      "merchantPlaceholder": "Tất cả merchant",
      "clear": "Xóa bộ lọc",
      "statusLabel": "Trạng thái",
      "statusAria": "Trạng thái credit",
      "expiryLabel": "Sắp hết hạn",
      "expiryAria": "Khoảng hết hạn"
    },
    "listSubtitle": "Credit liên merchant — bản ghi theo phiên bản, dùng FIFO từ credit cũ nhất còn hạn.",
    "loading": "Đang tải danh sách credit…",
    "status": {
      "active": "Đang hoạt động",
      "used": "Đã dùng",
      "expired": "Hết hạn",
      "revoked": "Đã thu hồi",
      "all": "Tất cả"
    },
    "expiry": {
      "any": "Bất kỳ",
      "withinDays": "≤ {{days}} ngày"
    },
    "empty": {
      "title": "Không có credit liên merchant.",
      "bodyBefore": "Mở chi tiết merchant rồi vào tab",
      "tabName": "Credit",
      "bodyAfter": "để cấp / chỉnh / thu hồi credit cho merchant đó."
    },
    "errors": {
      "loadFailed": "Không tải được danh sách credit"
    },
    "revoke": {
      "successTitle": "Đã thu hồi credit",
      "successDesc": "Lịch sử đã cập nhật.",
      "reasonRequired": "Lý do bắt buộc — từ 10 đến 500 ký tự.",
      "failedTitle": "Thu hồi credit thất bại",
      "dialogTitle": "Thu hồi credit",
      "merchantLabel": "Merchant:",
      "warning": "Phiên bản hiện tại: v{{version}}. Đã dùng vẫn nợ — merchant vẫn phải trả phần đã sử dụng. Hành động này không thể hoàn tác.",
      "reasonLabel": "Lý do thu hồi (10–500 ký tự)",
      "charsNeeded": "Cần thêm {{count}} ký tự",
      "lengthOk": "Đủ độ dài",
      "cancel": "Hủy",
      "submitting": "Đang thu hồi…",
      "submit": "Thu hồi"
    }
  },
  "gateway": {
    "title": "Cổng thanh toán",
    "subtitle": "Cấu hình và định tuyến cổng",
    "columns": {
      "name": "Cổng",
      "type": "Loại",
      "isActive": "Đang hoạt động",
      "priority": "Ưu tiên"
    },
    "actions": {
      "configure": "Cấu hình",
      "enable": "Bật",
      "disable": "Tắt",
      "testConnection": "Kiểm tra kết nối"
    },
    "errors": {
      "testFailed": "Kiểm tra kết nối thất bại",
      "missingCredentials": "Thiếu thông tin xác thực cổng"
    },
    "surfaces": {
      "ariaLabel": "Các bề mặt cổng thanh toán",
      "tabP8": "Cổng thanh toán",
      "tabP3": "Cấu hình cổng (9 nhà cung cấp)"
    },
    "settings": {
      "toast": {
        "savedTitle": "Đã lưu cấu hình gateway",
        "saveFailedTitle": "Không lưu được cấu hình",
        "webhookRegeneratedTitle": "Đã tái tạo webhook secret",
        "webhookRegeneratedDesc": "Cập nhật secret mới ở dashboard gateway để webhook tiếp tục verify.",
        "webhookRegenerateFailedTitle": "Không regenerate được webhook",
        "webhookCopiedTitle": "Đã copy webhook URL"
      },
      "loading": "Đang tải cấu hình {{gateway}}…",
      "loadFailedPrefix": "Không tải được:",
      "tierLockedTier1": "Tier 1 gateway — không hỗ trợ hot-swap.",
      "tierLockedTier2": "Tier 2 gateway — không hỗ trợ hot-swap.",
      "savingShort": "Đang lưu…",
      "save": "Lưu",
      "networkError": "Lỗi mạng — kiểm tra kết nối",
      "pauseDialog": {
        "titlePause": "Tạm dừng gateway {{gateway}}?",
        "titleResume": "Kích hoạt lại gateway {{gateway}}?",
        "descPause": "Hàng đợi BullMQ sẽ tạm dừng và merchant-portal hiện badge \"Maintenance\". Yêu cầu lý do (≥{{min}} ký tự) để ghi audit log.",
        "descResume": "Hàng đợi BullMQ sẽ tự động chạy lại. Ghi chú tuỳ chọn.",
        "reasonLabelPause": "Lý do (≥{{min}} ký tự)",
        "reasonLabelResume": "Ghi chú (tuỳ chọn)",
        "reasonPlaceholderPause": "VD: Nghi vấn fraud spike — tạm giữ điều tra",
        "reasonPlaceholderResume": "VD: Health check ổn 5 phút liền",
        "reasonTooShort": "Lý do phải có ít nhất {{min}} ký tự (hiện {{count}}).",
        "cancel": "Huỷ",
        "processing": "Đang xử lý…",
        "confirmPause": "Tạm dừng",
        "confirmResume": "Kích hoạt lại"
      },
      "pauseBanner": "Hàng đợi đang tạm dừng — merchant-portal hiển thị badge \"Maintenance\". Không auto-switch sang gateway khác.",
      "card": {
        "auditNotice": "Mọi lần hiển thị đều ghi audit log + tự ẩn sau 30s.",
        "statusHeading": "Trạng thái",
        "pause": "Tạm dừng",
        "resume": "Kích hoạt lại",
        "apiKey": "API key",
        "reveal": "Hiển thị",
        "statusLabel": "Trạng thái",
        "autoApprove": "Tự động duyệt",
        "yes": "Có",
        "no": "Không",
        "lastHealthCheck": "Lần kiểm tra gần nhất"
      },
      "toastP8": {
        "pausedTitle": "Đã tạm dừng {{gateway}}",
        "resumedTitle": "Đã kích hoạt lại {{gateway}}",
        "networkError": "Lỗi mạng — kiểm tra kết nối.",
        "alreadyPausedTitle": "Gateway đã tạm dừng",
        "pauseFailedTitle": "Không tạm dừng được",
        "notPausedTitle": "Gateway không ở trạng thái paused",
        "resumeFailedTitle": "Không kích hoạt lại được"
      },
      "panel": {
        "statusFilterLabel": "Trạng thái",
        "statusFilterAll": "Tất cả",
        "loadingList": "Đang tải danh sách gateway…",
        "loadFailedPrefix": "Không tải được:",
        "loadFailedUnknown": "lỗi không xác định",
        "empty": "Chưa có payment gateway nào ở trạng thái này.",
        "heading": "Cổng thanh toán",
        "subtitle": "Cấu hình gateway toàn nền tảng — credential ẩn, mô hình phí, tạm dừng/kích hoạt, health poll 60s.",
        "statusEnabled": "Đang bật",
        "statusPaused": "Đang tạm dừng",
        "statusDisabled": "Đã tắt"
      },
      "test": {
        "healthyTitle": "Khỏe mạnh",
        "failedTitle": "Kiểm tra thất bại",
        "nonOk": "Gateway trả về không OK",
        "connFailedTitle": "Kiểm tra kết nối thất bại",
        "testing": "Đang kiểm tra…",
        "testConnection": "Kiểm tra kết nối"
      },
      "health": {
        "untestedTitle": "Chưa có health check trực tiếp — nhấn Kiểm tra kết nối để ping gateway này.",
        "untested": "Chưa kiểm tra",
        "healthy": "Khỏe mạnh",
        "degraded": "Suy giảm",
        "down": "Ngừng hoạt động"
      },
      "legacy": {
        "heading": "Cài đặt Gateway (9-plugin cũ)",
        "subtitle": "Theo từng gateway: bật, tier mode, credential, kiểm tra sức khỏe"
      },
      "fields": {
        "enabled": "Đang bật",
        "tierMode": "Tier mode"
      },
      "tierOption": {
        "instant": "Instant (Tier 1{{lockSuffix}})",
        "manual": "Manual + IMAP (Tier 2{{lockSuffix}})",
        "lockedSuffix": " — đã khoá"
      },
      "credentials": {
        "heading": "Credential (đã mã hoá)",
        "placeholder": "Nhập credential",
        "fields": {
          "clientId": "Client ID",
          "clientSecret": "Client Secret",
          "publishableKey": "Publishable Key",
          "secretKey": "Secret Key",
          "webhookSecret": "Webhook Secret",
          "apiKey": "API Key",
          "partnerId": "Partner ID",
          "merchantId": "Merchant ID",
          "apiKeyOptional": "API Key (tùy chọn)"
        }
      },
      "webhook": {
        "heading": "Webhook URL",
        "copy": "Copy",
        "regenerate": "Tái tạo"
      },
      "imapPreview": {
        "heading": "Xem trước mẫu IMAP",
        "sender": "Người gửi",
        "txnId": "Mã giao dịch",
        "amount": "Số tiền",
        "editLink": "Sửa trong IMAP Config →"
      },
      "recentTx": {
        "heading": "Giao dịch gần đây",
        "empty": "Không có giao dịch gần đây",
        "colTxId": "Mã GD",
        "colAmount": "Số tiền",
        "colStatus": "Trạng thái",
        "colDate": "Ngày"
      },
      "regenConfirm": {
        "title": "Tái tạo webhook secret?",
        "desc": "Các tích hợp đang dùng secret cũ sẽ lỗi cho tới khi được cập nhật. Hành động không thể hoàn tác.",
        "confirm": "Tái tạo"
      },
      "p8health": {
        "lastCheck": "Kiểm tra gần nhất {{at}}",
        "noProbe": "Chưa probe",
        "maintenance": "Bảo trì (tạm dừng)",
        "healthy": "Khỏe mạnh",
        "degraded": "Suy giảm",
        "down": "Ngừng hoạt động"
      }
    },
    "feeForm": {
      "heading": "Cấu hình phí — {{gateway}}",
      "subtitle": "Vendor chịu phí gateway. Mọi thay đổi cần lý do để ghi audit log.",
      "modeLabel": "Mô hình phí",
      "mode": {
        "flat": "Flat — phí cố định ($X)",
        "percent": "Percentage — phần trăm (Y%)",
        "combined": "Combined — $X + Y%"
      },
      "flatLabel": "Phí cố định (USD)",
      "percentLabel": "Phí phần trăm (%)",
      "previewLabel": "Phí áp dụng:",
      "reasonLabel": "Lý do thay đổi",
      "reasonPlaceholder": "VD: Điều chỉnh theo hợp đồng vendor Q2",
      "saving": "Đang lưu…",
      "submit": "Lưu cấu hình phí",
      "toast": {
        "updatedTitle": "Đã cập nhật cấu hình phí",
        "auditLog": "Audit log: {{id}}",
        "saveFailedTitle": "Không lưu được cấu hình phí",
        "networkError": "Lỗi mạng — kiểm tra kết nối."
      },
      "errors": {
        "reasonMin": "Lý do thay đổi phải ≥ 5 ký tự",
        "flatMin": "Phí flat phải ≥ $0.00",
        "percentRange": "Phí phần trăm phải trong khoảng 0% – 100%",
        "combinedBoth": "Chế độ combined cần cả flat và percent > 0",
        "flatRequired": "Chế độ flat cần phí > $0.00",
        "percentRequired": "Chế độ percent cần phí > 0%"
      }
    },
    "reveal": {
      "ariaLabel": "Hiển thị API key — {{gateway}}",
      "title": "Hiển thị API key — {{gateway}}",
      "subtitle": "Mọi lần hiển thị đều được ghi vào audit log. Key sẽ tự động ẩn sau {{seconds}} giây.",
      "passwordLabel": "Mật khẩu của bạn",
      "passwordPlaceholder": "Tối thiểu 8 ký tự",
      "cancel": "Huỷ",
      "verifying": "Đang xác minh…",
      "submit": "Hiển thị",
      "autoHidePrefix": "Tự động ẩn sau",
      "autoHideSuffix": ". Đã ghi audit log.",
      "apiKeyLabel": "API key",
      "copy": "Copy",
      "hideNow": "Ẩn ngay",
      "toast": {
        "maskedTitle": "Đã ẩn API key",
        "maskedDesc": "API key đã được ẩn tự động sau thời gian xem.",
        "revealedTitle": "Đã hiển thị API key",
        "revealedDesc": "Key sẽ tự động ẩn sau {{seconds}}s — đã ghi log audit.",
        "rateLimitedTitle": "Quá nhiều lần thử",
        "rateLimitedDesc": "Vui lòng đợi vài phút rồi thử lại.",
        "revealFailedTitle": "Không hiển thị được API key",
        "networkError": "Lỗi mạng — kiểm tra kết nối.",
        "copied": "Đã copy API key"
      },
      "errors": {
        "passwordInvalid": "Mật khẩu xác nhận không đúng"
      }
    }
  },
  "payout": {
    "title": "Chi trả vendor",
    "subtitle": "Hàng đợi chi trả vendor",
    "columns": {
      "vendor": "Vendor",
      "amount": "Số tiền",
      "period": "Kỳ",
      "method": "Phương thức",
      "status": "Trạng thái"
    },
    "status": {
      "pending": "Chờ xử lý",
      "processing": "Đang xử lý",
      "paid": "Đã chi",
      "failed": "Thất bại",
      "cancelled": "Đã hủy"
    },
    "actions": {
      "process": "Xử lý",
      "retry": "Thử lại",
      "cancel": "Hủy"
    },
    "withdraw": {
      "relative": {
        "justNow": "vừa xong",
        "minutes": "{{count}} phút trước",
        "hours": "{{count}} giờ trước",
        "days": "{{count}} ngày trước"
      },
      "tab": {
        "all": "Tất cả",
        "pending": "Chờ duyệt",
        "approved": "Đã duyệt",
        "rejected": "Đã từ chối"
      },
      "status": {
        "pending": "Chờ duyệt",
        "approved": "Đã duyệt",
        "rejected": "Đã từ chối",
        "cancelled": "Đã hủy"
      },
      "raceLoser": {
        "title": "Đã được xử lý bởi admin khác",
        "description": "Yêu cầu này đã được duyệt hoặc từ chối — danh sách sẽ tải lại.",
        "descriptionShort": "Yêu cầu này đã được duyệt hoặc từ chối."
      },
      "networkErrorTitle": "Lỗi mạng",
      "checkConnection": "Kiểm tra kết nối",
      "loadFailed": "Không tải được hàng đợi rút tiền",
      "page": {
        "title": "Rút tiền của merchant",
        "subtitle": "Duyệt hoặc từ chối yêu cầu rút tiền của merchant (chi trả vendor nằm ở mục Chi trả vendor)"
      },
      "filterAria": "Lọc theo trạng thái rút tiền",
      "column": {
        "merchant": "Merchant",
        "amount": "Số tiền",
        "bankAccount": "Tài khoản ngân hàng",
        "date": "Ngày",
        "actions": "Thao tác"
      },
      "loading": "Đang tải…",
      "emptyPending": "Không có yêu cầu rút tiền chờ duyệt",
      "emptyAll": "Không tìm thấy yêu cầu nào",
      "emptyStatus": "Không tìm thấy yêu cầu {{status}}",
      "cancel": "Hủy",
      "view": "Xem",
      "close": "Đóng",
      "field": {
        "amount": "Số tiền",
        "bankAccount": "Tài khoản ngân hàng"
      },
      "internalNoteLabel": "Ghi chú nội bộ (tùy chọn)",
      "approve": {
        "refRequired": "Mã tham chiếu wire ngân hàng là bắt buộc",
        "refTooLong": "Mã tham chiếu quá dài (tối đa {{max}} ký tự)",
        "ledgerMissingTitle": "Không duyệt được — thiếu ledger",
        "ledgerMissingDesc": "Bản ghi pending này không có hold ledger entry tương ứng (dữ liệu lỗi). Liên hệ ops để re-seed hoặc hủy.",
        "failed": "Duyệt thất bại",
        "successTitle": "Đã duyệt rút tiền",
        "title": "Duyệt rút tiền — {{merchant}}",
        "refLabel": "Mã tham chiếu wire ngân hàng",
        "refPlaceholder": "vd: WF-WIRE-20260429-7788",
        "refHelp": "Bắt buộc — dán mã wire/ngân hàng bên ngoài sau khi đã chuyển tiền (lưu vết audit).",
        "internalNotePlaceholder": "Đã chuyển qua Wells Fargo…",
        "submitting": "Đang duyệt…",
        "submit": "Duyệt"
      },
      "reject": {
        "reasonMin": "Lý do là bắt buộc (tối thiểu {{min}} ký tự)",
        "reasonMax": "Lý do quá dài (tối đa {{max}} ký tự)",
        "failed": "Từ chối thất bại",
        "successTitle": "Đã từ chối rút tiền",
        "title": "Từ chối rút tiền — {{merchant}}",
        "reasonLabel": "Lý do",
        "reasonHelp": "Hiển thị cho merchant. 3-500 ký tự.",
        "internalNotePlaceholder": "Đã yêu cầu merchant cung cấp SWIFT mới…",
        "submitting": "Đang từ chối…",
        "submit": "Từ chối"
      },
      "detail": {
        "title": "Yêu cầu rút tiền — {{merchant}}",
        "merchant": "Merchant",
        "amount": "Số tiền",
        "bankAccount": "Tài khoản ngân hàng",
        "status": "Trạng thái",
        "requested": "Ngày yêu cầu",
        "approved": "Ngày duyệt",
        "wireRef": "Mã wire",
        "rejectReason": "Lý do từ chối"
      }
    },
    "markTransferred": {
      "ariaLabel": "Đánh dấu đã chuyển — {{vendor}}",
      "title": "Đánh dấu đã chuyển — {{vendor}}",
      "subtitleBefore": "Payout sẽ chuyển sang trạng thái ",
      "completedLabel": "Completed",
      "subtitleAfter": ". Hành động này được ghi vào audit log.",
      "invalidFormat": "Định dạng không hợp lệ. Chỉ chấp nhận PDF, JPG hoặc PNG.",
      "fileTooLarge": "File vượt quá giới hạn 5MB (hiện tại {{size}}MB).",
      "refTooShort": "Cần nhập mã chuyển khoản (tối thiểu {{min}} ký tự).",
      "refTooLong": "Mã chuyển khoản quá dài (tối đa {{max}} ký tự).",
      "refRequired": "Cần nhập mã tham chiếu chuyển khoản",
      "uploadFailed": "Upload chứng từ thất bại. Bạn có thể bỏ file đính kèm và thử lại, hoặc liên hệ ops.",
      "clearFile": "Bỏ",
      "cancel": "Huỷ",
      "submit": "Đánh dấu Completed",
      "submitting": "Đang xử lý…",
      "fields": {
        "netAmount": "Số tiền (net)",
        "vendor": "Vendor",
        "transferRef": "Mã tham chiếu chuyển khoản",
        "transferRefPlaceholder": "VD: WIRE-20260517-0042",
        "transferRefHelp": "Bắt buộc — dán mã wire / SWIFT confirmation sau khi chuyển khoản.",
        "proof": "Chứng từ bank statement (tuỳ chọn)",
        "proofHelp": "PDF, JPG hoặc PNG. Tối đa 5MB. File được lưu vào hệ thống và link xuất hiện trong chi tiết payout.",
        "notes": "Ghi chú (tuỳ chọn)",
        "notesPlaceholder": "VD: Đã xác nhận trên bank portal lúc 14:32."
      },
      "toast": {
        "successTitle": "Đã đánh dấu Transferred",
        "successDesc": "Payout {{vendor}} ({{amount}}) chuyển sang Completed.",
        "staleTitle": "Trạng thái payout đã thay đổi",
        "staleDesc": "Payout không còn ở trạng thái Processing — danh sách sẽ tải lại.",
        "failTitle": "Không đánh dấu được Transferred",
        "networkErrorTitle": "Lỗi mạng",
        "networkErrorDesc": "Kiểm tra kết nối và thử lại."
      }
    },
    "errors": {
      "network": "Lỗi mạng — kiểm tra kết nối",
      "unknown": "Lỗi không xác định"
    }
  },
  "transaction": {
    "title": "Giao dịch",
    "subtitle": "Sổ giao dịch liên merchant",
    "columns": {
      "id": "Mã giao dịch",
      "merchant": "Merchant",
      "type": "Loại",
      "amount": "Số tiền",
      "gateway": "Cổng",
      "createdAt": "Ngày tạo",
      "status": "Trạng thái",
      "direction": "Chiều",
      "merchantVendor": "Merchant / Vendor",
      "description": "Mô tả"
    },
    "type": {
      "topup": "Nạp tiền",
      "charge": "Thu phí",
      "refund": "Hoàn tiền",
      "adjustment": "Điều chỉnh",
      "withdrawal": "Rút tiền",
      "topup_credit": "Nạp tín dụng",
      "order_charge": "Thu phí đơn hàng",
      "refund_debit": "Ghi nợ hoàn tiền",
      "credit_grant": "Cấp tín dụng",
      "credit_use": "Dùng tín dụng",
      "payout_debit": "Ghi nợ chi trả",
      "gateway_fee": "Phí cổng",
      "manual_adjustment": "Điều chỉnh thủ công",
      "invoice_payment": "Thanh toán hóa đơn",
      "credit_memo_apply": "Áp dụng credit memo",
      "pre_payment": "Tạm ứng",
      "transfer_in": "Chuyển vào",
      "transfer_out": "Chuyển ra",
      "chargeback": "Chargeback (bồi hoàn)"
    },
    "status": {
      "succeeded": "Thành công",
      "pending": "Chờ xử lý",
      "failed": "Thất bại",
      "reversed": "Đã hoàn tác",
      "completed": "Hoàn tất"
    },
    "filters": {
      "type": "Loại",
      "gateway": "Cổng",
      "dateFrom": "Từ ngày",
      "dateTo": "Đến ngày",
      "amountMin": "Số tiền tối thiểu",
      "amountMax": "Số tiền tối đa",
      "merchant": "Merchant",
      "allMerchants": "Tất cả merchant",
      "vendor": "Vendor",
      "allVendors": "Tất cả vendor",
      "status": "Trạng thái",
      "allStatuses": "Tất cả trạng thái",
      "linkedOrderId": "Mã đơn hàng liên kết",
      "linkedOrderIdPlaceholder": "Dán mã đơn hàng",
      "linkedAdjustmentId": "Mã điều chỉnh / Credit-Memo liên kết",
      "linkedAdjustmentIdPlaceholder": "Dán mã điều chỉnh / credit-memo",
      "typeSelected": "Loại giao dịch (đã chọn {{count}}/14)",
      "clearTypes": "Bỏ chọn loại",
      "typeAria": "Bộ lọc loại giao dịch",
      "clearAll": "Xóa tất cả bộ lọc"
    },
    "page": {
      "description": "Sổ giao dịch liên merchant / vendor. Chỉ đọc — mọi giao dịch phát sinh từ màn hình nguồn (duyệt nạp tiền, hoàn tiền, chi trả, …)."
    },
    "toast": {
      "loadFailed": "Không tải được danh sách giao dịch",
      "unknownError": "Lỗi không xác định"
    },
    "summary": {
      "totalIn": "Tổng tiền vào",
      "totalOut": "Tổng tiền ra",
      "net": "Ròng",
      "pending": "Chờ xử lý"
    },
    "loading": "Đang tải…",
    "empty": "Không có giao dịch nào khớp bộ lọc hiện tại.",
    "savedViews": {
      "label": "Bộ lọc đã lưu:",
      "last24h": "24 giờ qua",
      "clear": "Xóa bộ lọc"
    },
    "search": {
      "label": "Tìm kiếm",
      "placeholder": "mã / mô tả / merchant / vendor"
    },
    "direction": {
      "in": "Vào",
      "out": "Ra"
    },
    "row": {
      "merchantLabel": "M:",
      "vendorLabel": "V:",
      "invoiceLabel": "hóa đơn:",
      "orderLabel": "đơn hàng:",
      "creditMemoLabel": "credit memo:"
    },
    "detail": {
      "back": "Giao dịch",
      "title": "Chi tiết giao dịch",
      "loading": "Đang tải…",
      "notFound": "Không tìm thấy giao dịch.",
      "directionIn": "Tiền vào",
      "directionOut": "Tiền ra",
      "order": "Đơn hàng",
      "invoice": "Hoá đơn",
      "time": "Thời gian",
      "linesHeading": "Bút toán (double-entry)",
      "account": "Tài khoản"
    }
  },
  "merchant_billing": {
    "title": "Billing Merchant",
    "subtitle": "Cấu hình billing cho từng merchant",
    "tabs": {
      "config": "Cấu hình",
      "invoices": "Hóa đơn",
      "credits": "Tín dụng",
      "history": "Lịch sử"
    },
    "fields": {
      "billingMode": "Chế độ billing",
      "currency": "Tiền tệ",
      "withdrawEnabled": "Cho phép rút tiền",
      "creditLimit": "Hạn mức tín dụng",
      "paymentTerms": "Thời hạn thanh toán (ngày)",
      "legalEntity": "Pháp nhân"
    },
    "actions": {
      "save": "Lưu thay đổi",
      "reset": "Đặt lại"
    },
    "loading": "Đang tải…",
    "merchantWithId": "Merchant {{id}}",
    "viewAllInvoices": "Xem tất cả hóa đơn",
    "errors": {
      "generic": "Có lỗi xảy ra",
      "loadConfigFailed": "Không tải được cấu hình billing",
      "networkErrorTitle": "Lỗi mạng",
      "networkError": "Lỗi mạng - kiểm tra kết nối",
      "loadInvoicesFailed": "Không tải được lịch sử hóa đơn",
      "missingMerchantId": "Thiếu merchant id trong URL."
    },
    "mode": {
      "heading": "Chế độ billing",
      "subheading": "Chuyển giữa PREPAID, CREDIT và INVOICE.",
      "quickSwitchLabel": "Chế độ billing (chuyển nhanh)",
      "selectPlaceholder": "Chọn chế độ…",
      "creditHint": "Dùng các tùy chọn đầy đủ bên dưới để chọn chế độ CREDIT.",
      "ariaLabel": "Chế độ billing",
      "walletFreezeWarning": "Ví sẽ bị đóng băng khi chuyển sang chế độ INVOICE. Số dư ví hiện tại được giữ ký quỹ cho đến khi hoàn trả.",
      "reasonLabel": "Lý do (nhật ký audit)",
      "reasonPlaceholder": "Vì sao bạn chuyển chế độ?",
      "adminOnly": "Chỉ admin",
      "switching": "Đang chuyển…",
      "saveBtn": "Lưu chế độ",
      "switchFailed": "Chuyển chế độ thất bại",
      "versionStaleTitle": "Phiên bản chế độ đã cũ",
      "updatedTitle": "Đã cập nhật chế độ billing",
      "updatedDesc": "Đã chuyển sang {{mode}}"
    },
    "modeOption": {
      "PREPAID": {
        "label": "Trả trước (ví)",
        "description": "Merchant nạp tiền vào ví trước. Không phát hành hóa đơn."
      },
      "CREDIT": {
        "label": "Tín dụng (tự nạp)",
        "description": "Ví tự nạp từ cổng đã lưu. Nạp thất bại → tạm ngưng."
      },
      "INVOICE": {
        "label": "Hóa đơn (công nợ NET)",
        "description": "Phát hành hóa đơn định kỳ theo chu kỳ. Merchant trả sau NET-N ngày kể từ ngày phát hành."
      }
    },
    "cycle": {
      "WEEKLY": "Hàng tuần",
      "BIWEEKLY": "Hai tuần một lần",
      "MONTHLY": "Hàng tháng"
    },
    "paymentMethod": {
      "BANK_TRANSFER": "Chuyển khoản ngân hàng",
      "GATEWAY": "Cổng thanh toán"
    },
    "invoiceStatus": {
      "DRAFT": "Nháp",
      "SENT": "Đã gửi",
      "PENDING_APPROVAL": "Chờ duyệt",
      "PAID": "Đã thanh toán",
      "PARTIAL": "Một phần",
      "OVERDUE": "Quá hạn",
      "VOIDED": "Đã hủy"
    },
    "outstanding": {
      "heading": "Dư nợ",
      "subheading": "Dư nợ gộp và thuần (soft cap).",
      "gross": "Dư nợ gộp",
      "net": "Dư nợ thuần",
      "netHint": "Sau khi áp dụng credit memo đang hoạt động",
      "softLimit": "Hạn mức mềm",
      "overCap": "Vượt hạn mức mềm — đơn hàng có thể bị chặn",
      "noSoftLimit": "Chưa cấu hình hạn mức mềm."
    },
    "config": {
      "heading": "Cấu hình billing",
      "subheading": "Chu kỳ, số ngày đến hạn, hạn mức tín dụng và phương thức thanh toán. Áp dụng cho merchant chế độ INVOICE.",
      "invoiceOnly": "Cấu hình billing chỉ áp dụng cho merchant chế độ INVOICE. Hãy chuyển chế độ trước.",
      "cycleLabel": "Chu kỳ",
      "dueDaysLabel": "Số ngày đến hạn (1–90)",
      "dueDayTypeLabel": "Loại ngày đến hạn",
      "dueDayTypeHelp": "Ngày làm việc = bỏ qua Thứ Bảy/Chủ Nhật. Khuyến nghị cho B2B theo chuẩn ngành.",
      "businessDays": "Ngày làm việc",
      "businessDaysHint": "(khuyến nghị — bỏ qua cuối tuần + ngày lễ của entity)",
      "calendarDays": "Ngày dương lịch",
      "calendarDaysHint": "(cộng ngày đơn giản)",
      "softLimitLabel": "Hạn mức mềm / Hạn mức tín dụng (USD, tùy chọn)",
      "softLimitPlaceholder": "vd: 50000",
      "paymentMethodsLabel": "Phương thức thanh toán",
      "withdrawLabel": "Quyền rút tiền",
      "withdrawManageTip": "Quản lý trong tab Ví",
      "withdrawEnterpriseTip": "Rút tiền chỉ dành cho hạng Enterprise",
      "withdrawDesc": "Cho phép merchant rút số dư ví",
      "withdrawTierHint": "— chỉ áp dụng hạng Enterprise (hiện tại: {{tier}})",
      "saving": "Đang lưu…",
      "saveBtn": "Lưu cấu hình",
      "validationFailed": "Kiểm tra dữ liệu thất bại",
      "saveFailed": "Không lưu được cấu hình billing",
      "savedTitle": "Đã lưu cấu hình billing",
      "savedDesc": "Đã cập nhật cho {{name}}",
      "merchantFallback": "merchant",
      "errors": {
        "dueDays": "Số ngày đến hạn phải từ 1 đến 90",
        "paymentMethods": "Chọn ít nhất một phương thức thanh toán",
        "softLimit": "Hạn mức mềm phải là số không âm"
      }
    },
    "invoices": {
      "heading": "Hóa đơn gần đây",
      "subheading": "Hóa đơn trước đây của merchant này. Xem tất cả trong trang Hóa đơn liên merchant.",
      "viewAll": "Xem tất cả",
      "columns": {
        "number": "Số hóa đơn",
        "period": "Kỳ",
        "amount": "Số tiền",
        "status": "Trạng thái",
        "due": "Đến hạn",
        "actions": "Hành động"
      },
      "loading": "Đang tải hóa đơn…",
      "empty": "Không có hóa đơn nào cho merchant này",
      "view": "Xem"
    },
    "settlement": {
      "title": "Tất toán dư nợ trước khi chuyển chế độ",
      "outstandingGross": "Dư nợ (gộp)",
      "creditsAvailable": "Credit memo đang hoạt động khả dụng",
      "activeMemos": "Credit memo đang hoạt động ({{count}})",
      "convertTitle": "Tất toán ngay — chuyển credit memo → ví",
      "convertDesc": "Chuyển {{amount}} từ credit memo vào ví merchant, rồi chuyển chế độ.",
      "carryTitle": "Chuyển tiếp — áp credit → dư nợ, rồi chuyển",
      "carryDesc": "Áp {{amount}} vào hóa đơn còn nợ trước, rồi chuyển chế độ.",
      "insufficientInline": "Vẫn còn nợ {{amount}} — chọn tùy chọn khác hoặc trả phần còn lại trước.",
      "refundTitle": "Hoàn credit memo về ngân hàng",
      "refundDesc": "Mở yêu cầu hoàn tiền ({{amount}}) để bộ phận tài chính chuyển về ngân hàng merchant, rồi chuyển chế độ.",
      "cancelTitle": "Hủy — giữ chế độ hiện tại",
      "cancelDesc": "Không chuyển. Xử lý dư nợ thủ công trước.",
      "close": "Đóng",
      "confirm": "Xác nhận chuyển sang {{mode}}",
      "insufficientTitle": "Không đủ credit memo",
      "insufficientDesc": "Vẫn còn nợ {{amount}} sau khi áp credit — chọn phương án tất toán khác.",
      "requiredTitle": "Cần tất toán"
    }
  },
  "manual_generate": {
    "backToInvoices": "Quay lại Invoices",
    "heading": "Tạo hóa đơn thủ công",
    "subtitlePrefix": "Ghi đè việc tạo hóa đơn theo chu kỳ tự động cho khoản phí phát sinh hoặc điều chỉnh. Hóa đơn thủ công được đánh số",
    "subtitleSuffix": ".",
    "steps": {
      "compose": "Soạn",
      "preview": "Xem trước & Xác nhận"
    },
    "merchantLabel": "Merchant",
    "merchantPlaceholder": "Chọn merchant chế độ INVOICE…",
    "merchantHintPrefix": "Chỉ liệt kê merchant ở chế độ billing INVOICE (bộ lọc phía server",
    "merchantHintSuffix": ").",
    "merchantInfo": {
      "title": "Thông tin merchant",
      "name": "Tên:",
      "phone": "Điện thoại:",
      "email": "Email:",
      "businessName": "Tên doanh nghiệp:",
      "taxId": "Mã số thuế:",
      "address": "Địa chỉ:"
    },
    "storeLabel": "Store",
    "storeAll": "— Tất cả store —",
    "gatewayLabel": "Cổng thanh toán",
    "gatewayAll": "— Tất cả cổng —",
    "cycleStartLabel": "Ngày bắt đầu kỳ",
    "cycleEndLabel": "Ngày kết thúc kỳ",
    "rangeHint": "Khoảng: {{days}} ngày (tối đa {{max}})",
    "taxLabel": "Số thuế tùy chỉnh (USD, tùy chọn)",
    "taxPlaceholder": "VD: 12.50",
    "taxHint": "Để trống để tự tính. Bộ máy tính thuế hoãn sang giai đoạn sau; cho phép nhập tay với hóa đơn B2B.",
    "markupLabel": "Markup đơn giá (%)",
    "markupPlaceholder": "VD: 5.0",
    "markupHint": "Áp dụng cho đơn giá từng dòng trước thuế.",
    "legalEntityLabel": "Pháp nhân",
    "legalEntityDefault": "— Mặc định —",
    "legalEntityDefaultSuffix": " — mặc định",
    "timezoneLabel": "Múi giờ",
    "notesLabel": "Ghi chú nội bộ (chỉ admin)",
    "notesPlaceholder": "Lý do tạo thủ công…",
    "notesCount": "{{count}}/500",
    "cancel": "Hủy",
    "preview": "Xem trước",
    "previewPanel": {
      "numberingPreview": "Xem trước đánh số:",
      "merchant": "Merchant",
      "billingMode": "Chế độ billing",
      "cycleWindow": "Kỳ",
      "cycleDays": "({{days}} ngày)",
      "tax": "Thuế",
      "internalNote": "Ghi chú nội bộ",
      "workerNotice": "Worker có thể mất vài giây. Tạm tính và tổng cuối được backend tổng hợp bởi worker tạo hóa đơn; bản xem trước này phản ánh dữ liệu bạn nhập, không phải tổng đã tính."
    },
    "backToEdit": "Quay lại chỉnh sửa",
    "generating": "Đang tạo…",
    "confirmGenerate": "Xác nhận & Tạo",
    "taxAuto": "Tự động (worker tính — hoãn sang giai đoạn sau)",
    "taxManual": "{{amount}} (nhập tay)",
    "errors": {
      "cycleEndOrder": "Ngày kết thúc kỳ phải bằng hoặc sau ngày bắt đầu kỳ.",
      "rangeMax": "Khoảng ngày phải ≤ {{max}} ngày (hiện {{days}} ngày).",
      "taxInvalid": "Số thuế phải là số không âm, tối đa 2 chữ số thập phân.",
      "completeBeforePreview": "Vui lòng hoàn tất merchant + kỳ trước khi xem trước.",
      "formInvalid": "Biểu mẫu không hợp lệ.",
      "noTransactions": "Không có order trong khoảng thời gian này — hóa đơn sẽ rỗng. Đổi kỳ hoặc đợi merchant phát sinh order."
    },
    "toast": {
      "noTransactionsTitle": "Không có dữ liệu trong kỳ",
      "failTitle": "Không tạo được hóa đơn",
      "successTitle": "Đã xếp hàng tạo hóa đơn · {{number}}",
      "successDesc": "Merchant {{merchant}} — kỳ {{from}} → {{to}}. Hóa đơn mới sẽ xuất hiện trong danh sách khi worker hoàn tất.",
      "networkTitle": "Lỗi mạng"
    }
  },
  "fraud": {
    "page": {
      "heading": "Cài đặt chống gian lận",
      "subtitle": "Giới hạn tần suất, quy tắc nạp tiền đáng ngờ, thời gian làm nguội"
    },
    "loading": "Đang tải cấu hình…",
    "loadFailedPrefix": "Không tải được cấu hình:",
    "unknown": "không xác định",
    "velocity": {
      "heading": "Giới hạn tần suất",
      "maxWithdraw": "Số lần rút tối đa / ngày mỗi merchant",
      "maxWithdrawHint": "Số tiền USD tối đa rút mỗi ngày (theo đô nguyên)",
      "maxTopup": "Số yêu cầu nạp tối đa / ngày mỗi merchant"
    },
    "suspicious": {
      "heading": "Cờ nạp tiền đáng ngờ",
      "countThreshold": "Ngưỡng số lượng đang chờ",
      "amountThreshold": "Ngưỡng tổng số tiền (USD)"
    },
    "cooling": {
      "heading": "Thời gian làm nguội",
      "defaultDays": "Số ngày làm nguội mặc định sau khi duyệt rút",
      "defaultDaysHint": "Đặt 0 để tắt làm nguội toàn cục"
    },
    "overrides": {
      "heading": "Ghi đè theo merchant",
      "description": "Tìm merchant theo tên / email → tuỳ chỉnh velocity / cooling độc lập với mặc định toàn cục. Ghi đè được ưu tiên hơn giá trị toàn cục.",
      "merchantPlaceholder": "Chọn merchant…",
      "open": "Mở ghi đè",
      "merchantLabel": "Merchant:",
      "loading": "Đang tải ghi đè…",
      "maxTopup": "Số yêu cầu nạp tối đa / ngày (ghi đè, để trống = kế thừa)",
      "maxWithdraw": "Số tiền rút tối đa / ngày USD (ghi đè)",
      "coolingDays": "Ghi đè thời gian làm nguội (ngày, 0 = tắt làm nguội)",
      "cancel": "Huỷ",
      "saving": "Đang lưu…",
      "save": "Lưu ghi đè"
    },
    "discard": "Bỏ thay đổi",
    "saving": "Đang lưu…",
    "saveChanges": "Lưu thay đổi",
    "toast": {
      "savedTitle": "Đã lưu cấu hình fraud",
      "saveFailedTitle": "Không lưu được cấu hình",
      "networkError": "Lỗi mạng — kiểm tra kết nối",
      "overrideSavedTitle": "Đã lưu override cho merchant",
      "overrideFailedTitle": "Không lưu được override",
      "noMerchantTitle": "Chưa chọn merchant",
      "noMerchantDesc": "Hãy chọn merchant trước khi mở overrides"
    }
  },
  "fx_rate": {
    "page": {
      "heading": "Tỷ giá ngoại tệ",
      "subtitle": "Tỷ giá theo từng gateway (nhấp ô để sửa). Cũ ≥{{days}} ngày sẽ được đánh dấu đỏ."
    },
    "addCurrency": "+ Thêm tiền tệ",
    "failedToLoad": "Tải thất bại",
    "allowed": {
      "heading": "Tiền tệ được phép",
      "description": "Mã ISO-4217 mà merchant được phép nạp. Thêm/xóa rồi nhấn Lưu.",
      "saving": "Đang lưu…",
      "save": "Lưu",
      "loading": "Đang tải…",
      "empty": "Chưa cho phép tiền tệ nào.",
      "removeAria": "Xóa {{code}}",
      "addLabel": "Thêm mã ISO-4217",
      "add": "+ Thêm",
      "unsavedHint": "Có thay đổi chưa lưu — nhấn Lưu bên trên."
    },
    "table": {
      "loading": "Đang tải tỷ giá…",
      "empty": "Chưa cấu hình tỷ giá nào",
      "colCurrency": "Tiền tệ",
      "colLastUpdated": "Cập nhật lần cuối",
      "markStale": "Đánh dấu cũ"
    },
    "confirm": {
      "markStale": "Đánh dấu {{currency}} là cũ?"
    },
    "modal": {
      "title": "Thêm tiền tệ",
      "codeLabel": "Mã ISO-4217 (vd: USD, EUR)",
      "gatewayLabel": "Gateway",
      "gatewayPlaceholder": "paypal | stripe | sunrate | …",
      "rateLabel": "Tỷ giá ban đầu (6 chữ số thập phân, vd: 1.080000)",
      "cancel": "Huỷ",
      "add": "Thêm"
    },
    "age": {
      "today": "hôm nay",
      "oneDayAgo": "1 ngày trước",
      "daysAgo": "{{days}} ngày trước",
      "daysStale": "{{days}} ngày (cũ)"
    },
    "toast": {
      "isoInvalid": "Mã ISO-4217 phải gồm 3 ký tự A-Z",
      "isoInvalidShort": "Mã ISO-4217 phải gồm 3 ký tự",
      "alreadyInList": "{{code}} đã có trong danh sách",
      "allowedSaved": "Đã lưu danh sách tiền tệ được phép",
      "allowedSaveFailed": "Không lưu được tiền tệ được phép",
      "networkError": "Lỗi mạng — kiểm tra kết nối",
      "rateSaved": "Đã lưu tỷ giá",
      "rateSaveFailed": "Không lưu được tỷ giá",
      "markedStale": "Đã đánh dấu tỷ giá là cũ",
      "markStaleFailed": "Không đánh dấu được cũ",
      "invalidRate": "Tỷ giá không hợp lệ",
      "invalidRateDesc": "Cần là số dương (ví dụ: 1.080000)",
      "gatewayRequired": "Cần chọn gateway"
    }
  },
  "imap": {
    "page": {
      "heading": "Cấu hình IMAP",
      "subtitle": "Trình phân tích email ngân hàng — kết nối hộp thư biên nhận và trích xuất chi tiết giao dịch"
    },
    "tabs": {
      "connection": "Kết nối",
      "matrix": "Parser theo từng gateway",
      "logs": "Nhật ký"
    },
    "connection": {
      "heading": "Kết nối",
      "host": "Host",
      "port": "Port",
      "secure": "Bảo mật (SSL/TLS)",
      "secureHint": "Dùng SSL/TLS (mã hoá kết nối tới mailbox)",
      "namespacePlaceholder": "vd: printway-bank-receipts",
      "namespaceHint": "Định danh nguồn idempotency — không được dùng từ chung \"imap\".",
      "email": "Email",
      "password": "Mật khẩu ứng dụng (app password)",
      "passwordPlaceholder": "Nhập mật khẩu ứng dụng",
      "pollInterval": "Chu kỳ poll (1–15 phút)",
      "pollCurrent": "Hiện tại: {{minutes}} phút"
    },
    "fields": {
      "sourceNamespace": "Source namespace"
    },
    "parserTest": {
      "heading": "Kiểm tra Parser",
      "gatewayLabel": "Parser gateway",
      "testing": "Đang kiểm tra…",
      "testButton": "Kiểm tra parse",
      "samplePlaceholder": "Dán email mẫu vào đây...",
      "resultHeading": "Kết quả phân tích",
      "matchYes": "Khớp: có",
      "txId": "Mã GD",
      "amount": "Số tiền",
      "none": "(không có)",
      "wouldLinkLabel": "Sẽ liên kết tới yêu cầu",
      "noMatchingRequest": "Không có yêu cầu đang chờ phù hợp",
      "matchNo": "Khớp: không — regex người gửi/giao dịch/số tiền không khớp mẫu này.",
      "runHint": "Chạy kiểm tra để xem trước kết quả parser"
    },
    "matrix": {
      "heading": "Ma trận regex theo từng gateway",
      "description": "Mỗi Tier 2 gateway cần 3 regex: lọc người gửi, trích mã giao dịch, trích số tiền.",
      "colGateway": "Gateway",
      "colSender": "Regex người gửi",
      "colTxnId": "Regex mã GD",
      "colAmount": "Regex số tiền",
      "senderPlaceholder": "^noreply@...",
      "txnIdPlaceholder": "Transaction ID:\\\\s*([A-Z0-9-]+)",
      "amountPlaceholder": "Amount:\\\\s*\\\\$?([0-9,.]+)"
    },
    "logs": {
      "heading": "Lịch sử phân tích (100 gần nhất)",
      "loading": "Đang tải nhật ký…",
      "loadFailed": "Không tải được nhật ký",
      "empty": "Chưa có hoạt động phân tích nào.",
      "colDate": "Ngày",
      "colSender": "Người gửi",
      "colGateway": "Gateway",
      "colMatch": "Khớp",
      "colTxId": "Mã GD",
      "colAmount": "Số tiền",
      "colLinked": "Liên kết",
      "yes": "có",
      "no": "không"
    },
    "discard": "Bỏ thay đổi",
    "saving": "Đang lưu…",
    "save": "Lưu",
    "validation": {
      "nsRequired": "Source namespace là bắt buộc",
      "nsFormat": "Phải bắt đầu bằng chữ cái; chỉ cho phép chữ cái, chữ số, _ và -",
      "nsForbidden": "Cấm dùng từ chung \"imap\" — hãy chọn namespace cụ thể hơn",
      "invalidRegex": "Regex không hợp lệ ở {{gateway}}.{{field}} — vui lòng sửa trước khi lưu"
    },
    "toast": {
      "savedTitle": "Đã lưu cấu hình IMAP",
      "saveFailedTitle": "Không lưu được IMAP",
      "networkError": "Lỗi mạng — kiểm tra kết nối",
      "testParseFailedTitle": "Kiểm tra parse thất bại"
    }
  },
  "chargeback": {
    "list": {
      "heading": "Chargeback",
      "subtitle": "Theo dõi các vụ chargeback của merchant — tiến độ thu hồi và hạn 7 ngày.",
      "loading": "Đang tải…",
      "empty": "Không có vụ chargeback nào cho bộ lọc này.",
      "rowAria": "Mở chargeback {{id}} của {{merchant}}",
      "colCaseId": "Mã vụ",
      "colMerchant": "Merchant",
      "colGateway": "Gateway",
      "colAmount": "Số tiền",
      "colStatus": "Trạng thái",
      "colDeadline": "Hạn chót"
    },
    "filters": {
      "ariaLabel": "Bộ lọc trạng thái chargeback",
      "all": "Tất cả vụ",
      "open": "Đang mở",
      "disputed": "Đang tranh chấp",
      "resolved": "Đã giải quyết",
      "debt_outstanding": "Còn nợ"
    },
    "detail": {
      "back": "Quay lại Chargebacks",
      "backToList": "Quay lại danh sách",
      "loading": "Đang tải vụ…",
      "notFound": "Không tìm thấy vụ.",
      "casePrefix": "Vụ",
      "subtitle": "{{gateway}} — khoản tính phí gốc {{amount}} — mở {{opened}}",
      "recoveryDeadline": "Hạn thu hồi: {{value}}",
      "caseDetails": "Chi tiết vụ",
      "gateway": "Gateway",
      "chargebackId": "Mã chargeback",
      "reasonCode": "Mã lý do",
      "originalCharge": "Khoản tính phí gốc",
      "merchant": "Merchant",
      "frozenAmount": "Số tiền đóng băng (gồm phí)",
      "recoveryProgress": "Tiến độ thu hồi",
      "debtRemaining": "Nợ còn lại"
    },
    "timeline": {
      "heading": "Dòng thời gian",
      "opened": "Chargeback đã mở",
      "openedDetail": "{{ago}} · đã đóng băng tiền ({{amount}})",
      "eventDetail": "{{ago}} · {{id}}",
      "approaching": "Sắp tới hạn thu hồi",
      "approachingDetail": "trong {{time}} · còn lại {{debt}}",
      "passed": "Đã quá hạn thu hồi",
      "passedDetail": "{{debt}} chưa thu hồi"
    },
    "actions": {
      "heading": "Hành động",
      "resolve": "Giải quyết thủ công",
      "addNote": "Thêm ghi chú admin",
      "markLost": "Đánh dấu thua (xóa nợ)",
      "note": "Hệ thống tự thu hồi khi merchant nạp tiền. Giải quyết thủ công chỉ dành cho cấp admin."
    },
    "deadline": {
      "passed": "Đã quá hạn",
      "remaining": "còn {{time}}",
      "hoursOnly": "{{hours}}h",
      "daysHours": "{{days}}n {{hours}}h"
    },
    "timeAgo": {
      "dayAgo": "{{count}} ngày trước",
      "daysAgo": "{{count}} ngày trước",
      "hourAgo": "{{count}} giờ trước",
      "hoursAgo": "{{count}} giờ trước",
      "justNow": "vừa xong"
    },
    "status": {
      "open": "Đang mở",
      "investigating": "Đang điều tra",
      "resolved_won": "Đã giải quyết (thắng)",
      "resolved_lost": "Đã giải quyết (thua)",
      "disputed": "Đang tranh chấp",
      "resolved": "Đã giải quyết",
      "debt_outstanding": "Còn nợ",
      "frozen_pending_recovery": "Đóng băng — chờ thu hồi"
    },
    "outcome": {
      "won": "thắng",
      "resolved": "đã giải quyết",
      "lost": "thua",
      "expired": "hết hạn"
    },
    "cancel": "Huỷ",
    "toast": {
      "loadDetailFailed": "Không tải được chargeback",
      "loadListFailed": "Không tải được danh sách chargeback",
      "networkError": "Lỗi mạng",
      "checkConnection": "Kiểm tra kết nối"
    },
    "resolve": {
      "title": "Giải quyết chargeback thủ công",
      "outcomeLabel": "Kết quả",
      "outcomeWon": "Thắng (đảo ngược tranh chấp)",
      "outcomeResolved": "Đã giải quyết (đã thu hồi)",
      "outcomeLost": "Thua (xóa nợ)",
      "outcomeExpired": "Hết hạn (đã quá hạn chót)",
      "terminalHint": "Trạng thái kết thúc — không thể mở lại vụ từ trang này.",
      "noteLabel": "Ghi chú (tuỳ chọn)",
      "notePlaceholder": "Ghi chú nội bộ — ngữ cảnh cho audit trail (tối đa 500 ký tự)",
      "submitting": "Đang giải quyết…",
      "submit": "Giải quyết",
      "toast": {
        "failed": "Giải quyết thất bại",
        "success": "Đã giải quyết chargeback",
        "successDesc": "Đã đánh dấu là {{outcome}}"
      }
    },
    "addNote": {
      "title": "Thêm ghi chú admin",
      "noteLabel": "Ghi chú",
      "notePlaceholder": "Ngữ cảnh nội bộ — trao đổi, kết quả điều tra, v.v. (tối đa 500 ký tự)",
      "hint": "Ghi chú chỉ thêm mới và được lưu kèm mã admin của bạn.",
      "submitting": "Đang lưu…",
      "submit": "Lưu ghi chú",
      "toast": {
        "requiredTitle": "Cần ghi chú",
        "requiredDesc": "Vui lòng nhập ghi chú trước khi lưu.",
        "failed": "Thêm ghi chú thất bại",
        "success": "Đã thêm ghi chú",
        "successDesc": "Đã lưu ghi chú admin vào audit trail"
      }
    },
    "markLost": {
      "title": "Đánh dấu chargeback là thua?",
      "irreversible": "Hành động này không thể hoàn tác.",
      "bodyPrefix": "Vụ",
      "bodySuffix": "sẽ bị xóa nợ. Khoản nợ tồn đọng vẫn nằm trên sổ cái và vụ này sẽ không còn tự thu hồi từ các lần nạp tiền của merchant.",
      "submitting": "Đang đánh dấu…",
      "confirm": "Xác nhận — đánh dấu thua",
      "toast": {
        "failed": "Đánh dấu thua thất bại",
        "success": "Đã đánh dấu chargeback là thua",
        "successDesc": "Đã xóa nợ {{id}}"
      }
    }
  },
  "merchant_picker": {
    "title": "Chọn merchant",
    "searchPlaceholder": "Tìm theo tên, email hoặc ID…",
    "loading": "Đang tải…",
    "noResults": "Không tìm thấy merchant phù hợp",
    "prompt": "Gõ để tìm merchant theo tên / email / ID"
  },
  "errors": {
    "requestFailed": "Yêu cầu thất bại (HTTP {{status}})"
  },
  "whitelist": {
    "title": "Whitelist",
    "subtitle": "Các quyền theo từng merchant, mặc định đóng cho tới khi admin mở.",
    "tab": {
      "merchants": "Merchant",
      "paymentMethods": "Phương thức thanh toán",
      "config": "Cấu hình",
      "log": "Nhật ký"
    },
    "merchants": {
      "heading": "Whitelist thanh toán bằng thẻ",
      "hint": "Merchant được phép trả đơn và hoá đơn thẳng bằng thẻ đã lưu, không qua ví. Bật cho từng merchant ở Chi tiết merchant → Wallet & Billing.",
      "search": "Tìm theo tên hoặc email",
      "colName": "Merchant",
      "colEmail": "Email",
      "colPerOrder": "Trần mỗi lần",
      "colPerDay": "Trần mỗi ngày",
      "noLimit": "Không giới hạn",
      "empty": "Chưa có merchant nào được bật thanh toán bằng thẻ.",
      "loadError": "Không tải được danh sách whitelist.",
      "count": "{{count}} merchant",
      "add": {
        "heading": "Thêm merchant",
        "hint": "Mở thanh toán thẻ trực tiếp cho merchant này. Để trống ô trần nghĩa là không giới hạn.",
        "merchantLabel": "Merchant",
        "perOrderLabel": "Trần mỗi lần ($)",
        "perDayLabel": "Trần mỗi ngày ($)",
        "submit": "Thêm vào whitelist",
        "submitting": "Đang thêm…",
        "pickMerchant": "Hãy chọn merchant trước.",
        "badAmount": "Nhập số tiền hợp lệ, hoặc để trống nếu không giới hạn.",
        "alreadyListed": "Merchant này đã có trong whitelist.",
        "failed": "Không thêm được merchant này.",
        "added": "Đã thêm merchant vào whitelist.",
        "noLimitConfirm": "Tôi xác nhận để trống nghĩa là không giới hạn",
        "noLimitRequired": "Để trống hạn mức nghĩa là chi tiêu thẻ không giới hạn — tích ô xác nhận, hoặc nhập số tiền."
      },
      "picker": {
        "title": "Chọn merchant",
        "searchPlaceholder": "Tìm theo tên, email hoặc ID…",
        "loading": "Đang tải…",
        "noResults": "Không tìm thấy merchant phù hợp",
        "prompt": "Gõ để tìm theo tên, email hoặc ID"
      },
      "colActions": "Thao tác",
      "remove": {
        "cta": "Gỡ",
        "confirmTitle": "Gỡ khỏi whitelist?",
        "confirmBody": "{{name}} sẽ mất lựa chọn thanh toán bằng thẻ ngay lập tức, ở mọi màn thanh toán. Trần tiền đã đặt vẫn được giữ, nên bật lại sau này không bắt đầu từ mức không giới hạn.",
        "confirmCta": "Gỡ",
        "done": "Đã gỡ merchant khỏi whitelist.",
        "failed": "Không gỡ được merchant này."
      },
      "removing": "Đang gỡ…",
      "noPermission": "Bạn không có quyền thay đổi whitelist."
    },
    "paymentMethods": {
      "heading": "Phương thức mở cho merchant trong whitelist",
      "hint": "Hiện chỉ thẻ Stripe trừ thẳng được. PayPal chưa có luồng lưu tài khoản nên không dùng để trả trực tiếp được.",
      "stripe": "Stripe (thẻ đã lưu)",
      "stripeOn": "Đang khả dụng",
      "stripeOff": "Cổng đang tắt — bật ở Gateway Settings trước",
      "stripeUnknown": "Không đọc được trạng thái cổng thanh toán — đây không phải là xác nhận Stripe đang tắt.",
      "paypal": "PayPal",
      "paypalUnsupported": "Chưa hỗ trợ — không có luồng lưu tài khoản"
    },
    "config": {
      "heading": "Quy tắc admin không tắt được",
      "invoiceRule": "Merchant tính tiền theo hoá đơn trả được hoá đơn bằng thẻ, nhưng không trả được từng đơn — đơn đó sẽ bị tính tiền lần nữa vào hoá đơn kỳ sau.",
      "refundRule": "Khoản đã trừ thẻ không hoàn ngược về thẻ từ đây được. Tiền hoàn vào ví merchant.",
      "threeDsRule": "Thẻ cần xác thực 3-D Secure sẽ bị từ chối — luồng này không có bước xác thực tại chỗ.",
      "limitsHint": "Trần mỗi lần và trần mỗi ngày đặt riêng cho từng merchant. Để trống nghĩa là không giới hạn.",
      "fraudLink": "Cấu hình chống gian lận"
    },
    "noAccess": "Bạn không có quyền xem danh sách whitelist.",
    "log": {
      "heading": "Ai đã đổi gì",
      "hint": "Mỗi lần admin mở, đóng, hoặc đổi trần thanh toán thẻ của một merchant.",
      "colTime": "Thời gian",
      "colAdmin": "Admin",
      "colMerchant": "Merchant",
      "colChange": "Thay đổi",
      "colLimits": "Trần sau khi đổi",
      "change": {
        "added": "Thêm vào",
        "removed": "Gỡ khỏi",
        "limits": "Đổi trần"
      },
      "filter": {
        "from": "Từ ngày",
        "to": "Đến ngày"
      },
      "empty": "Chưa ghi nhận thay đổi whitelist nào.",
      "loadError": "Không tải được nhật ký.",
      "loadMore": "Tải thêm",
      "unknownAdmin": "—",
      "noLimit": "Không giới hạn",
      "legacyNote": "Các dòng ghi trước khi có nhật ký này có thể không hiện tên admin."
    }
  }
}
